webpackJsonp([66],{

/***/ "++vR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("6oYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3361679b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("592B");
function injectStyle (ssrContext) {
  __webpack_require__("+CM/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3361679b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3361679b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+9ro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-alert',
  computed: {
    alertClass: function alertClass() {
      return {
        'with-close': this.withCloseBtn,
        'alert-success': this.type === 'success',
        'alert-danger': this.type === 'danger',
        'alert-warning': this.type === 'warning',
        'alert-info': this.type === 'info'
      };
    }
  },
  props: {
    type: {
      type: String,
      default: 'success'
    },
    withCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hidden: false
    };
  },

  methods: {
    hide: function hide() {
      this.hidden = true;
    }
  }
});

/***/ }),

/***/ "+CM/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Igv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+ihS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)},[_c('div',{staticClass:"circle-inner-container",style:(_vm.circleInnerContainerStyle)},[_c('div',{staticClass:"circle-inner",style:(_vm.circleInnerStyle)})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+s3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

});

/***/ }),

/***/ "+tWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "//9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticLog_vue__ = __webpack_require__("8U+t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b523c11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticLog_vue__ = __webpack_require__("AnNF");
function injectStyle (ssrContext) {
  __webpack_require__("9m1z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b523c11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b523c11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/2Db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCheckbox_vue__ = __webpack_require__("fJoC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af6ebc0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCheckbox_vue__ = __webpack_require__("bzB/");
function injectStyle (ssrContext) {
  __webpack_require__("nZ+C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af6ebc0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/5zc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/VHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__ = __webpack_require__("4IzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__ = __webpack_require__("10Vv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__ = __webpack_require__("WOMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__ = __webpack_require__("ehv0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__ = __webpack_require__("NHch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__ = __webpack_require__("zb58");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chart',
  props: ['data', 'options', 'type'],
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__["a" /* default */],
    VerticalBarChart: __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__["a" /* default */],
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__["a" /* default */],
    DonutChart: __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__["a" /* default */],
    BubbleChart: __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__["a" /* default */]
  }
});

/***/ }),

/***/ "/XqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__ = __webpack_require__("2QDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__ = __webpack_require__("Ci0K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__ = __webpack_require__("jrTD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__ = __webpack_require__("VoWT");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-progress-bar',
  components: {
    HorizontalBar: __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__["a" /* default */],
    VerticalBar: __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__["a" /* default */],
    CircleBar: __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__["a" /* default */]
  },
  props: {
    type: {
      type: String,
      default: 'horizontal'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    size: {
      type: String,
      default: 'basic'
    },
    colorName: {
      type: String,
      default: 'primary'
    },
    startColorName: {
      type: String,
      default: 'lighterGray'
    },
    backgroundColorName: {
      type: String,
      default: 'white'
    }
  },
  watch: {
    value: function value() {
      this.animateValue();
    }
  },
  methods: {
    animateValue: function animateValue() {
      var _this = this;

      var startValue = this.value;
      var valueMsecs = this.valueAnimationInterval / this.max;
      var delta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(this.value - this.animatedValue);
      var valueInterval = setInterval(function () {
        if (!_this.$refs.bar) {
          clearInterval(valueInterval);
          return;
        }
        if (startValue !== _this.value || _this.animatedValue === _this.value) {
          clearInterval(valueInterval);
          if (_this.value === _this.max) {
            _this.isActive = false;
          }
        } else {
          _this.animatedValue += delta;
        }
      }, valueMsecs);
    }
  },
  data: function data() {
    return {
      value: 0,
      valueAnimationInterval: 2000,
      animatedValue: 0,
      isActive: false,
      startColor: this.$store.state.app.config.palette[this.startColorName],
      color: this.$store.state.app.config.palette[this.colorName],
      backgroundColor: this.$store.state.app.config.palette[this.backgroundColorName]
    };
  }
});

/***/ }),

/***/ "/gWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile-section',

  data: function data() {
    return {
      show: true
    };
  },


  props: {
    options: {
      type: Array,
      default: function _default() {
        return [{
          name: 'profile'
        }, {
          name: 'logout'
        }];
      }
    }
  },

  methods: {
    onClick: function onClick(name) {
      switch (name) {
        case 'profile':
          break;
        case 'logout':
          this.$refs.smallModal.open();
          break;
      }
    }
  }
});

/***/ }),

/***/ "/ucK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_directives_ResizeHandler__ = __webpack_require__("noQ4");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-layout',

  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    resize: __WEBPACK_IMPORTED_MODULE_0_directives_ResizeHandler__["a" /* default */]
  },
  computed: {
    classObject: function classObject() {
      return {
        'layout-fixed': this.fixed
      };
    }
  }
});

/***/ }),

/***/ "03Zi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "06SC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "08VY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-pre-loader-stsc"},[_c('fingerprint-spinner',{attrs:{"animation-duration":1500,"size":104,"color":"#F9B542"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0CcK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__ = __webpack_require__("obAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f775501e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__ = __webpack_require__("SVED");
function injectStyle (ssrContext) {
  __webpack_require__("23FJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f775501e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Gsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-root"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0HaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("YMqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39520b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("OLG1");
function injectStyle (ssrContext) {
  __webpack_require__("mKJi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39520b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0O39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group dropdown"},[_c('button',{staticClass:"btn btn-primary btn-sm dropdown-toggle",attrs:{"id":"itemsPerPageBtn","type":"button","data-toggle":"dropdown"}},[_vm._v("\n    "+_vm._s(_vm.selected)+" "+_vm._s(_vm.label)+"\n    "),_c('i',{staticClass:"ion-ios-arrow-down arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.selectedItemsPerPage(option.value)}}},[_vm._v(_vm._s(option.value)+" per page")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "10Vv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bubble"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp],
  props: ['chartData', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.chartData, options);
  }
}));

/***/ }),

/***/ "10yw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__ = __webpack_require__("U2Zt");




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__["a" /* default */]
  },
  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    defaultPerPage: {
      type: Number
    }
  },
  data: function data() {
    return {
      selected: this.defaultPerPage
    };
  },
  mounted: function mounted() {
    this.selectedItemsPerPage(this.selected);
  },


  methods: {
    selectedItemsPerPage: function selectedItemsPerPage(optionValue) {
      this.selected = optionValue;
      this.$emit('items-per-page', this.selected);
    }
  }
});

/***/ }),

/***/ "1MF6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1mf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("vi3p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92c052a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("tKDr");
function injectStyle (ssrContext) {
  __webpack_require__("VFNt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-92c052a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92c052a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1xaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__ = __webpack_require__("7VXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12113120_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__ = __webpack_require__("frcY");
function injectStyle (ssrContext) {
  __webpack_require__("4Hyn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12113120_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "23FJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Bcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        if (i === 1) {
          style.marginLeft = 0;
        }

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "2IXP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Nev":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_components_vuestic_alert_VuesticAlert_vue__ = __webpack_require__("EV/8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_components_vuestic_breadcrumbs_VuesticBreadcrumbs_vue__ = __webpack_require__("vh2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuestic_components_vuestic_chart_VuesticChart_vue__ = __webpack_require__("tgcS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuestic_components_vuestic_chat_VuesticChat_vue__ = __webpack_require__("Gu02");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__ = __webpack_require__("/2Db");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuestic_components_vuestic_datatable_VuesticDataTable_vue__ = __webpack_require__("0CcK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_feed_VuesticFeed_vue__ = __webpack_require__("M9rz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_log_VuesticLog_vue__ = __webpack_require__("//9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__ = __webpack_require__("u+5M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuestic_components_vuestic_modal_VuesticModal_vue__ = __webpack_require__("uxTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__ = __webpack_require__("1xaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuestic_components_vuestic_popover_VuesticPopover_vue__ = __webpack_require__("ihPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("9xHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vuestic_components_vuestic_preloader_stsc_VuesticPreLoaderSTSC_vue__ = __webpack_require__("PcFD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__ = __webpack_require__("9NsT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__ = __webpack_require__("niZM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__ = __webpack_require__("BdMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("Y+KL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__ = __webpack_require__("0HaH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__vuestic_components_vuestic_slider_VuesticSlider_vue__ = __webpack_require__("fPvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__vuestic_components_vuestic_social_news_VuesticSocialNews_vue__ = __webpack_require__("W3ZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__vuestic_components_vuestic_switch_VuesticSwitch_vue__ = __webpack_require__("yPiP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__vuestic_components_vuestic_tabs_VuesticTabs_vue__ = __webpack_require__("K08g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__vuestic_components_vuestic_tooltip_VuesticTooltip_vue__ = __webpack_require__("xQQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__vuestic_components_vuestic_widget_VuesticWidget_vue__ = __webpack_require__("TVMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__vuestic_components_vuestic_wizard_VuesticWizard_vue__ = __webpack_require__("aHv1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__vuestic_components_vuestic_tree_view_VuesticTreeRoot__ = __webpack_require__("vHzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__vuestic_components_vuestic_tree_view_VuesticTreeCategory__ = __webpack_require__("WXh0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__vuestic_components_vuestic_tree_view_VuesticTreeNode__ = __webpack_require__("IkPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__vuestic_components_vuestic_date_picker_VuesticDatePicker__ = __webpack_require__("S0Tt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__vuestic_mixins_VuesticToasted__ = __webpack_require__("fB5I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__vuestic_directives_Dropdown__ = __webpack_require__("U2Zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__vuestic_directives_StickyScroll__ = __webpack_require__("qLPH");




































var VuesticPlugin = {
  install: function install(Vue, options) {
    [__WEBPACK_IMPORTED_MODULE_0__vuestic_components_vuestic_alert_VuesticAlert_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__vuestic_components_vuestic_breadcrumbs_VuesticBreadcrumbs_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__vuestic_components_vuestic_chart_VuesticChart_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__vuestic_components_vuestic_chat_VuesticChat_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__vuestic_components_vuestic_datatable_VuesticDataTable_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_feed_VuesticFeed_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_log_VuesticLog_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__vuestic_components_vuestic_modal_VuesticModal_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__vuestic_components_vuestic_preloader_stsc_VuesticPreLoaderSTSC_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__vuestic_components_vuestic_slider_VuesticSlider_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__vuestic_components_vuestic_social_news_VuesticSocialNews_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__vuestic_components_vuestic_switch_VuesticSwitch_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__vuestic_components_vuestic_tabs_VuesticTabs_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__vuestic_components_vuestic_widget_VuesticWidget_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__vuestic_components_vuestic_wizard_VuesticWizard_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__vuestic_components_vuestic_tooltip_VuesticTooltip_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__vuestic_components_vuestic_popover_VuesticPopover_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__vuestic_components_vuestic_tree_view_VuesticTreeRoot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__vuestic_components_vuestic_tree_view_VuesticTreeCategory__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__vuestic_components_vuestic_tree_view_VuesticTreeNode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__vuestic_components_vuestic_date_picker_VuesticDatePicker__["a" /* default */]].forEach(function (component) {
      Vue.component(component.name, component);
    });

    Vue.mixin(__WEBPACK_IMPORTED_MODULE_30__vuestic_mixins_VuesticToasted__["a" /* default */]);

    Vue.directive('dropdown', __WEBPACK_IMPORTED_MODULE_31__vuestic_directives_Dropdown__["a" /* default */]);
    Vue.directive('sticky-scroll', __WEBPACK_IMPORTED_MODULE_32__vuestic_directives_StickyScroll__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VuesticPlugin);

/***/ }),

/***/ "2XB0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2XLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticNavbar_vue__ = __webpack_require__("KzeC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06283cd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticNavbar_vue__ = __webpack_require__("ol33");
function injectStyle (ssrContext) {
  __webpack_require__("1MF6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06283cd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ab3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ "2iiT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_theme_vuestic_components_vuestic_layout_VuesticLayout__ = __webpack_require__("7mf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_navbar_AppNavbar__ = __webpack_require__("M8Jl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_sidebar_AppSidebar__ = __webpack_require__("cdM8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-layout',

  components: {
    VuesticLayout: __WEBPACK_IMPORTED_MODULE_1__vuestic_theme_vuestic_components_vuestic_layout_VuesticLayout__["a" /* default */],
    AppNavbar: __WEBPACK_IMPORTED_MODULE_2__app_navbar_AppNavbar__["default"],
    AppSidebar: __WEBPACK_IMPORTED_MODULE_3__app_sidebar_AppSidebar__["default"]
  },

  data: function data() {
    return {
      opened: true
    };
  },


  methods: {
    toggleSidebar: function toggleSidebar(opened) {
      this.opened = opened;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isLoading']))
});

/***/ }),

/***/ "2sGy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2u3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
});

/***/ }),

/***/ "313/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pixel-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"pixel-spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Alh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "3Cfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-selector',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  }
});

/***/ }),

/***/ "3JM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]),_vm._v(" "),_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Uqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swapping-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3VgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_div_checkbox_SquareWithIcon_vue__ = __webpack_require__("eOeK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__ = __webpack_require__("/2Db");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-category',
  components: { SquareWithIcon: __WEBPACK_IMPORTED_MODULE_0__vuestic_div_checkbox_SquareWithIcon_vue__["a" /* default */], VuesticCheckbox: __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__["a" /* default */] },
  data: function data() {
    return {
      isOpenCached: false
    };
  },

  watch: {
    isOpen: {
      handler: function handler(isOpen) {
        this.isOpenCached = isOpen;
      },

      immediate: true
    }
  },
  props: {
    label: {
      type: [String, Number],
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkboxIconClass: function checkboxIconClass() {
      return this.isOpenCached ? 'ion ion-md-remove' : 'ion ion-md-add';
    }
  },
  methods: {
    collapse: function collapse() {
      var _this = this;

      this.isOpenCached = false;
      this.$nextTick(function () {
        _this.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.collapse();
          }
        });
      });
    },
    expand: function expand() {
      var _this2 = this;

      this.isOpenCached = true;
      this.$nextTick(function () {
        _this2.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.expand();
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "3ZnJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Hyn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4IzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Pie"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp],
  props: ['chartData', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.chartData, options);
  }
}));

/***/ }),

/***/ "4J/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-popover',

  components: { VPopover: __WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* VPopover */] },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'auto'
    },
    popoverClass: {
      type: [String, Array],
      default: 'vuestic-tooltip'
    },
    autoHide: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isIconPresent: function isIconPresent() {
      return !!this.$slots.icon;
    }
  }
});

/***/ }),

/***/ "4TJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__ = __webpack_require__("2ab3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4bUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("tcEG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a1c5f7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("Vfss");
function injectStyle (ssrContext) {
  __webpack_require__("7Cg+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a1c5f7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a1c5f7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4c85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-building-square-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:{'clear': index && index % 3 === 0},style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4pm6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "592B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-square-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5AY4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5AYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarLink__ = __webpack_require__("SZ1I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_expanding_src_Expanding__ = __webpack_require__("OPFe");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-link-group',
  components: {
    SidebarLink: __WEBPACK_IMPORTED_MODULE_0__SidebarLink__["default"],
    Expanding: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_expanding_src_Expanding__["a" /* default */]
  },
  data: function data() {
    return {
      expanded: this.expanded
    };
  },
  mounted: function mounted() {
    var linkGroup = this.$refs.linkGroupWrapper;
    if (linkGroup.querySelector('.router-link-active') !== null) {
      this.expanded = true;
    }
  },

  watch: {
    $route: function $route(route) {
      this.expanded = false;
    }
  },
  methods: {
    toggleMenuItem: function toggleMenuItem() {
      this.expanded = !this.expanded;
    }
  },
  computed: {
    classObject: function classObject() {
      return {
        'expanded': this.expanded
      };
    }
  }
});

/***/ }),

/***/ "5TPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-node",class:{'vuestic-tree-node-selected': _vm.selected}},[(_vm.$slots.checkbox)?_c('div',{staticClass:"vuestic-tree-node-checkbox"},[_vm._t("checkbox")],2):_vm._e(),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"vuestic-tree-node-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vuestic-tree-node-label"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.iconRight)?_c('div',{staticClass:"vuestic-tree-node-icon-right"},[_vm._t("iconRight")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "66yB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_theme_vuestic_components_vuestic_sidebar_VuesticSidebar__ = __webpack_require__("Z9Vt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SidebarLink__ = __webpack_require__("SZ1I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SidebarLinkGroup__ = __webpack_require__("xrxJ");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-sidebar',
  components: {
    VuesticSidebar: __WEBPACK_IMPORTED_MODULE_1__vuestic_theme_vuestic_components_vuestic_sidebar_VuesticSidebar__["a" /* default */],
    SidebarLink: __WEBPACK_IMPORTED_MODULE_3__components_SidebarLink__["default"],
    SidebarLinkGroup: __WEBPACK_IMPORTED_MODULE_4__components_SidebarLinkGroup__["default"]
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['toggleWithoutAnimation']))
});

/***/ }),

/***/ "6D2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ev5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6oYg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "77C1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__("mUJ2")("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),

/***/ "7Cg+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7F3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__("4TJE");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ "7Kca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orbit-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"orbit one",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit two",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit three",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7VXJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__ = __webpack_require__("U2Zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("Y+KL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-multi-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["a" /* default */]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: '',
      validated: false
    };
  },

  props: {
    label: String,
    itemsChosenPlaceholder: {
      type: String,
      default: 'chosen'
    },
    options: Array,
    value: Array,
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'multiselect'
    }
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    toggleSelection: function toggleSelection(option) {
      var newVal = this.isOptionSelected(option) ? this.deselectOption(option) : this.selectOption(option);
      this.updateDisplayValue(newVal);
      this.$emit('input', newVal);
    },
    isOptionSelected: function isOptionSelected(option) {
      return this.value.includes(option);
    },
    selectOption: function selectOption(option) {
      return this.value.concat(option);
    },
    deselectOption: function deselectOption(option) {
      return this.value.filter(function (item) {
        return item !== option;
      });
    },
    updateDisplayValue: function updateDisplayValue(newVal) {
      var _this = this;

      if (newVal.length > 2) {
        this.displayValue = newVal.length + '/' + this.options.length + ' ' + this.itemsChosenPlaceholder;
      } else {
        this.displayValue = (this.optionKey ? newVal.map(function (item) {
          return item[_this.optionKey];
        }) : newVal).join(', ');
      }
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "7mf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticLayout_vue__ = __webpack_require__("/ucK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1136b049_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticLayout_vue__ = __webpack_require__("lx53");
function injectStyle (ssrContext) {
  __webpack_require__("ApTl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1136b049_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7mhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7qYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  itemsPerPage: [{
    value: 5
  }, {
    value: 6
  }, {
    value: 10
  }]
});

/***/ }),

/***/ "8U+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-log',

  props: {
    section: {
      type: String,
      default: ''
    }
  },

  computed: {
    returnTableData: function returnTableData() {
      var _this = this;

      var d = this.$root.log;
      d = d.filter(function (item) {
        return item.section === _this.section;
      });
      return d;
    }
  },

  methods: {
    getIconClass: function getIconClass(row) {
      return {
        'fa-check success-icon': row.success === true,
        'fa-exclamation-triangle error-icon': row.success === false
      };
    },
    getBadgeClass: function getBadgeClass(row) {
      return {
        'badge-success': row.action === 'add',
        'badge-info': row.action === 'edit',
        'badge-danger': row.action === 'remove'
      };
    }
  }
});

/***/ }),

/***/ "8bIR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spring-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spring-spinner-part top",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})]),_vm._v(" "),_c('div',{staticClass:"spring-spinner-part bottom",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8ovZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "8vMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle-1",style:(_vm.circle1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle-2",style:(_vm.circle2Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "922U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-profile-card d-flex flex-column align-items-center"},[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.photoSource}})]),_vm._v(" "),_c('h5',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',{staticClass:"location"},[_c('span',{staticClass:"icon glyphicon glyphicon-map-marker"}),_vm._v(" "+_vm._s(_vm.location))]),_vm._v(" "),_c('div',{staticClass:"social"},[(_vm.social.facebook)?_c('a',{staticClass:"icon brandico brandico-facebook-rect",attrs:{"href":'http://' + _vm.social.facebook,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.instagram)?_c('a',{staticClass:"icon brandico brandico-instagram",attrs:{"href":'http://' + _vm.social.instagram,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.twitter)?_c('a',{staticClass:"icon brandico brandico-twitter",attrs:{"href":'http://' + _vm.social.twitter,"target":"_blank"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9AED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "9C+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kewler__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-pre-loader',
  methods: {
    getPrevious: function getPrevious(index) {
      if (index === 0) return this.points.length - 1;else return index - 1;
    },
    getNext: function getNext(index) {
      if (index + 1 === this.points.length) {
        return 0;
      } else {
        return index + 1;
      }
    },
    setNextLighten: function setNextLighten(index) {
      var lighten = this.points[index].lighten;
      this.points[index].lighten = lighten === 8 ? 1 : lighten + 1;
    },
    draw: function draw() {
      var _this = this;

      var ctx = this.context;
      ctx.clearRect(0, 0, 140, 104);
      var padding = 4;
      this.points.forEach(function (point) {
        ctx.beginPath();
        var delta = _this.radius + padding;
        ctx.arc(point.x + delta, point.y + delta, _this.radius, 0, Math.PI * 2, false);
        ctx.fillStyle = _this.color(Object(__WEBPACK_IMPORTED_MODULE_1_kewler__["lightness"])(point.lighten / 10 * 35))();
        ctx.fill();
      });
      var main = this.points[this.mainIndex];
      var delta = this.mainRadius - this.radius + padding;
      ctx.beginPath();
      ctx.arc(main.x + delta, main.y + delta, this.mainRadius, 0, Math.PI * 2, false);
      ctx.fillStyle = this.color();
      ctx.fill();
      ctx.closePath();
    },
    calculate: function calculate() {
      this.mainIndex = this.getNext(this.mainIndex);
      var prevIndex = this.mainIndex;
      for (var i = 0; i <= 7; i++) {
        prevIndex = this.getPrevious(prevIndex);
        this.setNextLighten(prevIndex);
      }
    },
    update: function update() {
      this.calculate();
      this.draw();
    },
    animate: function animate() {
      this.interval = setInterval(this.update, 30);
    },
    stop: function stop() {
      clearInterval(this.interval);
    }
  },
  mounted: function mounted() {
    this.context = this.$refs.canvas.getContext('2d');
    this.points = this.points.map(function (point) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        lighten: 8
      }, point);
    });
    for (var i = 1; i <= 7; i++) {
      this.points[this.mainIndex - i].lighten = i;
    }
    this.draw();
    this.animate();
  },
  data: function data() {
    return {
      points: __webpack_require__("nErf"),
      color: Object(__WEBPACK_IMPORTED_MODULE_1_kewler__["color"])(this.$store.state.app.config.palette.primary),
      mainIndex: 7,
      context: {},
      radius: 4,
      mainRadius: 8,
      interval: {}
    };
  }
});

/***/ }),

/***/ "9NsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__ = __webpack_require__("iLy1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0907bec0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__ = __webpack_require__("922U");
function injectStyle (ssrContext) {
  __webpack_require__("H3ug")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0907bec0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9RFk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"nav d-lg-none"},[_c('router-link',{staticClass:"i-vuestic-stsc",attrs:{"to":{path: '/'}}})],1),_vm._v(" "),_c('div',{staticClass:"main row"},[_c('div',{staticClass:"auth-content col-lg-6 col-12"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"auth-wallpaper col-6 d-none d-lg-flex"},[_c('div',{staticClass:"oblique"}),_vm._v(" "),_c('router-link',{staticClass:"i-vuestic-stsc",attrs:{"to":{path: '/'}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9g8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-with-icon"},[_c('span',{staticClass:"icon"},[_c('i',{class:_vm.iconClass,attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9m1z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9xHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__ = __webpack_require__("9C+P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50689a71_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__ = __webpack_require__("V6Tn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50689a71_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AO3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__ = __webpack_require__("9AED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_45872dc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__ = __webpack_require__("7Kca");
function injectStyle (ssrContext) {
  __webpack_require__("+Igv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45872dc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_45872dc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AlLt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"orientation-handler",rawName:"v-orientation-handler",value:({ layout: _vm.wizardLayout,  breakPoint: _vm.orientationBreakPoint }),expression:"{ layout: wizardLayout,  breakPoint: orientationBreakPoint }"}],staticClass:"wizard",class:_vm.computedLayout},[(_vm.computedLayout === 'horizontal')?_c('div',{staticClass:"indicator-container indicator-container-horizontal"},[(_vm.wizardType === 'simple')?_c('simple-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'rich')?_c('rich-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.computedLayout === 'vertical')?_c('div',{staticClass:"indicator-container indicator-container-vertical"},[(_vm.wizardType === 'rich')?_c('rich-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'simple')?_c('simple-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wizard-body"},[_vm._l((_vm.steps),function(step){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isStepShown(step)),expression:"isStepShown(step)"}],staticClass:"wizard-body-step"},[_vm._t(step.slot)],2)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.wizardCompleted),expression:"wizardCompleted"}],staticClass:"wizard-body-step"},[_vm._t(_vm.wizardCompletedSlotName)],2),_vm._v(" "),(!_vm.wizardCompleted)?_c('div',{staticClass:"wizard-body-actions"},[(_vm.backEnabled)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-secondary wizard-back pull-left",on:{"click":function($event){$event.preventDefault();_vm.goBack()}}},[_vm._v("\n          Back\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.isLastStep())?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right",on:{"click":function($event){$event.preventDefault();_vm.goNext()}}},[_vm._v("\n          Next\n        ")])]):_vm._e(),_vm._v(" "),(_vm.currentStep == _vm.steps.length - 1)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right final-step",on:{"click":function($event){$event.preventDefault();_vm.isConfirmWizard()}}},[_vm._v("\n          "+_vm._s(_vm.lastStepLabel)+"\n        ")])]):_vm._e()]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AnNF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-sm color-icon-label-table"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("translate")('tables.headings.time')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("translate")('tables.headings.log')))]),_vm._v(" "),_c('td',{attrs:{"align":"middle"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.returnTableData),function(log,ilog){return _c('tr',{key:ilog},[_c('td',[_c('span',{staticClass:"badge badge-pill",class:_vm.getBadgeClass(log)},[_vm._v(_vm._s(log.action))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.created_at))]),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s('<strong>' + log.who + '</strong>' + ' ' + log.action + ' ' + log.target + ' ' + log.id + ', section ' + log.section)}}),_vm._v(" "),_c('td',{staticClass:"valid",attrs:{"align":"middle"}},[_c('i',{staticClass:"fa icon-right input-icon",class:_vm.getIconClass(log)})])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ApTl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ArcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trinity-rings-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle1",style:(_vm.ring1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle2",style:(_vm.ring2Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle3",style:(_vm.ring3Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AyHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__ = __webpack_require__("8ovZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4bec2f04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__ = __webpack_require__("byLN");
function injectStyle (ssrContext) {
  __webpack_require__("6D2+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bec2f04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4bec2f04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BKK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("r8Mc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e59ea346_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("4c85");
function injectStyle (ssrContext) {
  __webpack_require__("YUQB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e59ea346"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e59ea346_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BOqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__ = __webpack_require__("7F3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72c1be7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__ = __webpack_require__("CXmD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72c1be7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BQX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-category"},[_c('div',{staticClass:"vuestic-tree-category__header",on:{"click":function($event){_vm.isOpenCached = ! _vm.isOpenCached}}},[_c('div',{staticClass:"vuestic-tree-category__header-checkbox"},[_c('square-with-icon',{attrs:{"iconClass":_vm.checkboxIconClass}})],1),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"vuestic-tree-category__header-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vuestic-tree-category__header-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])]),_vm._v(" "),(_vm.isOpenCached)?_c('div',{staticClass:"vuestic-tree-category__list-container"},[_c('div',{staticClass:"vuestic-tree-category__list-internal-container"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BcT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'square-with-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "BdMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticRadioButton_vue__ = __webpack_require__("GFLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3e8638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticRadioButton_vue__ = __webpack_require__("ZHXW");
function injectStyle (ssrContext) {
  __webpack_require__("GU5N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticRadioButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3e8638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticRadioButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C9Ox":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CXmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tablePagination && _vm.tablePagination.last_page > 1),expression:"tablePagination && tablePagination.last_page > 1"}],class:_vm.css.wrapperClass},[_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(1)}}},[(_vm.css.icons.first != '')?_c('i',{class:[_vm.css.icons.first]}):_c('span',[_vm._v("«")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('prev')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.prev]}):_c('span',[_vm._v(" ‹")])]),_vm._v(" "),(_vm.notEnoughPages)?[_vm._l((_vm.totalPage),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(n)},on:{"click":function($event){_vm.loadPage(n)}}})]})]:[_vm._l((_vm.windowSize),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart+n-1) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(_vm.windowStart+n-1)},on:{"click":function($event){_vm.loadPage(_vm.windowStart+n-1)}}})]})],_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('next')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.next]}):_c('span',[_vm._v("› ")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(_vm.totalPage)}}},[(_vm.css.icons.last != '')?_c('i',{class:[_vm.css.icons.last]}):_c('span',[_vm._v("»")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CdEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"semipolar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"ring",style:(rs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ci0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__ = __webpack_require__("f2UZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db3c3a16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__ = __webpack_require__("STeQ");
function injectStyle (ssrContext) {
  __webpack_require__("oRuh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db3c3a16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ClNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sidebar-link-group sidebar-link",class:_vm.classObject},[_c('a',{staticClass:"sidebar-link__router-link",attrs:{"href":"#","target":"_self"},on:{"click":function($event){_vm.toggleMenuItem()}}},[_vm._t("title"),_vm._v(" "),_c('i',{staticClass:"expand-icon fa fa-angle-down"})],2),_vm._v(" "),_c('expanding',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(this.expanded),expression:"this.expanded"}],ref:"linkGroupWrapper",staticClass:"sidebar-submenu in"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CqZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageDropdown_vue__ = __webpack_require__("xEkJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c1dd831_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageDropdown_vue__ = __webpack_require__("hWKn");
function injectStyle (ssrContext) {
  __webpack_require__("2sGy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c1dd831_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DHwG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_WITHOUT_ANIMATION; });
var CLOSE_MENU = 'CLOSE_MENU';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION';

/***/ }),

/***/ "EV/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__ = __webpack_require__("+9ro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40ba69de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__ = __webpack_require__("ihFO");
function injectStyle (ssrContext) {
  __webpack_require__("TUXY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40ba69de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40ba69de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Eb6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__ = __webpack_require__("Qlvq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d49154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__ = __webpack_require__("9RFk");
function injectStyle (ssrContext) {
  __webpack_require__("Qgdr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d49154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EjwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intersecting-circles-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinnerBlock",style:(_vm.spinnerBlockStyle)},_vm._l((_vm.circleStyles),function(cs,index){return _c('span',{key:index,staticClass:"circle",style:(cs)})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eo30":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"profile-dropdown col nav-item dropdown navbar-dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":""}},[_c('span',{staticClass:"profile-section-avatar-container"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu last"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option,id){return _c('div',{key:id,staticClass:"dropdown-item plain-link-item",on:{"click":function($event){$event.preventDefault();_vm.onClick(option.name)}}},[_c('a',{staticClass:"plain-link"},[_vm._v(_vm._s(_vm._f("translate")(("user." + (option.name)))))])])}))]),_vm._v(" "),_c('vuestic-modal',{ref:"smallModal",attrs:{"show":_vm.show,"small":true,"cancelClass":'none',"okText":_vm._f("translate")('modal.confirm'),"cancelText":_vm._f("translate")('modal.cancel')},on:{"update:show":function($event){_vm.show=$event},"ok":function($event){_vm.signOut()}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm._f("translate")('modal.confirmTitle')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("translate")('modal.confirmQuitMessage')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FmT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-switch"},[_c('div',{staticClass:"vuestic-switch-option true-option",class:{'active': _vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(true)}}},[_vm._t("trueTitle")],2),_vm._v(" "),_c('div',{staticClass:"vuestic-switch-option false-option",class:{'active': !_vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(false)}}},[_vm._t("falseTitle")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fsqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding_src_Expanding__ = __webpack_require__("OPFe");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-sidebar',
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding_src_Expanding__["a" /* default */]
  },
  props: {
    hidden: {
      type: Boolean,
      required: true
    },
    toggleWithoutAnimation: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    classObject: function classObject() {
      return {
        'sidebar-hidden': !this.toggleWithoutAnimation && !this.hidden,
        'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.hidden
      };
    }
  }
});

/***/ }),

/***/ "GFLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-radio-button',
  props: {
    label: String,
    value: {
      type: String,
      default: '',
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      default: undefined
    },
    brandColor: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  mounted: function mounted() {
    if (this.checked && !this.checkState) {
      this.toggle();
    }
  },

  methods: {
    onChange: function onChange() {
      this.toggle();
    },
    toggle: function toggle() {
      this.$emit('input', this.checkState ? '' : this.value);
    }
  },
  computed: {
    checkState: function checkState() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    },
    additionalClasses: function additionalClasses() {
      return ['abc-radio-' + this.brandColor];
    }
  },
  watch: {
    checked: function checked(newValue) {
      if (newValue !== this.checkState) {
        this.toggle();
      }
    }
  }
});

/***/ }),

/***/ "GFiP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GTd2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GU5N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ggsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gu02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__ = __webpack_require__("gMVf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9d9225_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__ = __webpack_require__("XK7D");
function injectStyle (ssrContext) {
  __webpack_require__("2IXP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c9d9225"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9d9225_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H3ug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H65f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "HouA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageDropdown_vue__ = __webpack_require__("Wg4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16404740_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageDropdown_vue__ = __webpack_require__("riaA");
function injectStyle (ssrContext) {
  __webpack_require__("DHwG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16404740_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IQ8j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__ = __webpack_require__("kmDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("UjVw");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: true,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */]
  },
  state: {},
  mutations: {}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].plugin, store);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IebZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IkPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_vue__ = __webpack_require__("Z6hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a4229a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_vue__ = __webpack_require__("5TPX");
function injectStyle (ssrContext) {
  __webpack_require__("GTd2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a4229a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JT6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("2Bcf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f00a11e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("sxwz");
function injectStyle (ssrContext) {
  __webpack_require__("K5cK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f00a11e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f00a11e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JVbn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tabs"},[_c('div',{staticClass:"d-none d-md-block"},[_c('nav',{staticClass:"nav nav-pills row"},_vm._l((_vm.names),function(name){return _c('div',{staticClass:"nav-item col",class:{active: name === _vm.currentActive},on:{"click":function($event){_vm.setActive(name)}}},[_c('span',{staticClass:"nav-link"},[_c('h5',[_vm._v(_vm._s(name))])])])})),_vm._v(" "),_c('div',{staticClass:"track"},[_c('div',{class:_vm.underscoreClass})])]),_vm._v(" "),_c('vuestic-simple-select',{staticClass:"d-flex d-md-none d-lg-none d-xl-none simple-select",attrs:{"options":_vm.names},model:{value:(_vm.currentActive),callback:function ($$v) {_vm.currentActive=$$v},expression:"currentActive"}}),_vm._v(" "),_c('div',{staticClass:"tab-content"},_vm._l((_vm.names),function(name){return _c('div',{staticClass:"tab-pane",class:{active: name === _vm.currentActive}},[_vm._t(name)],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JoHn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K08g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__ = __webpack_require__("kfHw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7029791e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__ = __webpack_require__("JVbn");
function injectStyle (ssrContext) {
  __webpack_require__("XNYc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7029791e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K5cK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K82C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("ml8A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_695bf2d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("nljM");
function injectStyle (ssrContext) {
  __webpack_require__("gAE+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-695bf2d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_695bf2d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KMiR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  table: {
    tableClass: 'table table-striped table-header-active',
    ascendingIcon: 'entypo entypo-up-dir',
    descendingIcon: 'entypo entypo-down-dir'
  },
  pagination: {
    wrapperClass: 'btn-group',
    activeClass: 'focus',
    disabledClass: 'disabled',
    pageClass: 'btn btn-primary hide-not-focused-btn',
    linkClass: 'btn btn-primary pagination-link-btn',
    icons: {
      first: 'fa fa-angle-double-left',
      prev: 'fa fa-angle-left',
      next: 'fa fa-angle-right',
      last: 'fa fa-angle-double-right'
    }
  }
});

/***/ }),

/***/ "KPAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kss2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filterBar',
  props: {
    label: {
      type: String
    }
  },
  data: function data() {
    return {
      filterText: '',
      typingTimeout: null,
      typingDelay: 250
    };
  },

  methods: {
    doFilter: function doFilter() {
      var _this = this;

      this.typingTimeout && clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(function () {
        return _this.$emit('filter', _this.filterText);
      }, this.typingDelay);
    }
  }
});

/***/ }),

/***/ "KzeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-navbar'
});

/***/ }),

/***/ "L5nV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],staticClass:"vuestic-tooltip-target"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LLbi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-flatpickr-component',_vm._g({staticClass:"vuestic-date-picker",class:{'has-value': _vm.valueProxy && _vm.valueProxy.length},attrs:{"config":_vm.fullConfig},model:{value:(_vm.valueProxy),callback:function ($$v) {_vm.valueProxy=$$v},expression:"valueProxy"}},_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M8Jl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppNavbar_vue__ = __webpack_require__("TLp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6089bd73_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNavbar_vue__ = __webpack_require__("PLt5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6089bd73_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24dc55bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ggsd");
function injectStyle (ssrContext) {
  __webpack_require__("Wpql")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24dc55bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M975":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-link',
  props: {
    to: {
      type: Object,
      required: true
    }
  },
  watch: {
    $route: function $route(route) {
      var _this = this;

      this.$nextTick(function () {
        var isActive = _this.$children[0].$el.classList.contains('router-link-active');
        if (!isActive) {
          return;
        }
        var linkGroup = _this.$parent && _this.$parent.$parent;
        if (linkGroup.$options.name !== 'sidebar-link-group') {
          return;
        }
        linkGroup.expanded = true;
      });
    }
  }
});

/***/ }),

/***/ "M9rz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__ = __webpack_require__("qB2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111057b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__ = __webpack_require__("ypPw");
function injectStyle (ssrContext) {
  __webpack_require__("ORei")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111057b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MyMC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"id":"input-icon-left","name":"input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter()},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N6Uh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallerDotAnimationBaseName: 'flower-spinner-smaller-dot-animation',
      biggerDotAnimationBaseName: 'flower-spinner-bigger-dot-animation',
      currentSmallerDotAnimationBaseName: '',
      currentBiggerDotAnimationBaseName: ''
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentSmallerDotAnimationBaseName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentBiggerDotAnimationBaseName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentSmallerDotAnimationBaseName, this.generateSmallerDotKeyframes());
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentBiggerDotAnimationBaseName, this.generateBiggerDotKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentSmallerDotAnimationBaseName = this.smallerDotAnimationBaseName + '-' + Date.now();
      this.currentBiggerDotAnimationBaseName = this.biggerDotAnimationBaseName + '-' + Date.now();
    },
    generateSmallerDotKeyframes: function generateSmallerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    },
    generateBiggerDotKeyframes: function generateBiggerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                50% {\n                  transform: rotate(180deg);\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  transform: rotate(360deg);\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    }
  }
});

/***/ }),

/***/ "NHch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bar"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp],
  props: ['chartData', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.chartData, options);
  }
}));

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuestic_theme_vuestic_plugin__ = __webpack_require__("2Nev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_yandex_maps__ = __webpack_require__("Hlu6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_yandex_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_yandex_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_firebase_auth__ = __webpack_require__("dih4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase_storage__ = __webpack_require__("cWbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__firebase_util__ = __webpack_require__("Pxmi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__firebase_util__);





















__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vuestic_theme_vuestic_plugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_yandex_maps___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vuefire___default.a);

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate___default.a, { fieldsBagName: 'formFields' });

var configFirebase = {
  'adminBoard': {
    apiKey: 'AIzaSyC_lKcTuPZXJfKFbw5Tp4XuM-4mjYllsWw',
    authDomain: 'stscadminboard.firebaseapp.com',
    databaseURL: 'https://stscadminboard.firebaseio.com',
    projectId: 'stscadminboard',
    storageBucket: 'stscadminboard.appspot.com',
    messagingSenderId: '199060262470'
  }
};
var dashboardApp = __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.initializeApp(configFirebase.adminBoard);
var dbDashboardApp = dashboardApp.database();

var mediaHandler = function mediaHandler() {
  if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.config.windowMatchSizeLg).matches) {
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('toggleSidebar', true);
  } else {
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('toggleSidebar', false);
  }
};

__WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setLoading', true);
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && to.path !== '/auth/login') {
    __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
      if (user !== null && user !== undefined) {
        next();
      } else {
        next({
          path: '/auth/login',
          query: { redirect: to.fullPath }
        });
      }
    });
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].afterEach(function (to, from) {
  mediaHandler();
  __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setLoading', false);
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].mixin({
  data: function data() {
    return {
      firebaseApp: __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a,
      firebaseAuth: __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.auth(),
      icon: {
        success: 'fa-check-circle',
        error: 'fa-exclamation-circle',
        info: 'fa-info-circle'
      },
      toast: {
        text: 'This toast is awesome!',
        type: 'info',
        icon: 'fa-star-o',
        duration: 4000,
        position: 'top-center',
        isFullWidth: false
      }
    };
  },

  methods: {
    signOut: function signOut() {
      var _this = this;

      try {
        this.firebaseAuth.signOut().then(function () {
          _this.$router.push('/');
        }).catch(function (err) {
          if (_this.isNotNullorUndefined(err)) {
            _this.launchToast(err.message, 'error');
          }
        });
      } catch (err) {
        if (this.isNotNullorUndefined(err)) {
          this.launchToast(err.message, 'error');
        }
      }
    },
    clear: function clear(field) {
      this[field] = '';
    },
    getMaxArray: function getMaxArray(array) {
      return Math.max.apply(Math, array);
    },
    getMinArray: function getMinArray(array) {
      return Math.min.apply(Math, array);
    },
    arrayHasElements: function arrayHasElements(array) {
      try {
        return array.length > 0;
      } catch (e) {
        return false;
      }
    },
    whichQuestionType: function whichQuestionType(t) {
      var choiceTypeArray = ['Multiple Choice', 'Picture Choice', 'Single Choice'];
      var textTypeArray = ['Short Text', 'Date', 'Email'];
      var scaleTypeArray = ['Opinion Scale', 'Rating'];

      if (choiceTypeArray.indexOf(t) > -1) return 'choice';else if (textTypeArray.indexOf(t) > -1) return 'text';else if (scaleTypeArray.indexOf(t) > -1) return 'scale';else return 'yesno';
    },
    isNotNullorUndefined: function isNotNullorUndefined(item) {
      return item !== null && item !== undefined;
    },
    isFormFieldValid: function isFormFieldValid(field) {
      var isValid = false;
      if (this.formFields[field]) {
        isValid = this.formFields[field].validated && this.formFields[field].valid;
      }
      return isValid;
    },
    validateFormField: function validateFormField(fieldName) {
      this.$validator.validate(fieldName, this[fieldName]);
    },
    foundDulicateInArray: function foundDulicateInArray(a) {
      for (var i = 0; i <= a.length; i++) {
        for (var j = i; j <= a.length; j++) {
          if (i !== j && a[i] === a[j]) {
            return true;
          }
        }
      }
      return false;
    },
    launchToast: function launchToast(message, type, icon, duration, position) {
      var m = message || this.toast.text;
      var t = type || this.toast.type;
      var i = this.icon[t] || this.toast.icon;
      this.showToast(m, {
        type: t,
        icon: i,
        duration: duration || this.toast.duration,
        position: position || this.toast.position,
        fullWidth: this.toast.isFullWidth
      });
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    routeQuery: function routeQuery() {
      return this.$route.query;
    },
    getCurrentUser: function getCurrentUser() {
      return __WEBPACK_IMPORTED_MODULE_12_firebase_app___default.a.auth().currentUser;
    },
    getTimestamp: function getTimestamp() {
      return new Date().getTime();
    },
    getNewDateWTime: function getNewDateWTime() {
      var a = new Date();
      var year = a.getFullYear();
      var month = ('0' + (a.getMonth() + 1)).slice(-2);
      var date = ('0' + a.getDate()).slice(-2);
      var hour = ('0' + a.getHours()).slice(-2);
      var min = ('0' + a.getMinutes()).slice(-2);
      var sec = ('0' + a.getSeconds()).slice(-2);

      return date + '-' + month + '-' + year + '@' + hour + ':' + min + ':' + sec;
    },
    getLog: function getLog(action, target, id, section, success, errMessage) {
      return {
        'action': action || 'add',
        'target': target || 'question',
        'id': id || null,
        'section': section || 'survey/questions',
        'success': success || true,
        'errormessage': errMessage || null,
        'who': this.getCurrentUser().email,
        'created_at': this.getNewDateWTime()
      };
    },
    getSavedExtraInfo: function getSavedExtraInfo(saveData) {
      if (this.isNotNullorUndefined(saveData) && (typeof saveData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(saveData)) === 'object') {
        var extraData = {
          'id': this.getTimestamp(),
          'created_at': this.getNewDateWTime(),
          'created_by': this.getCurrentUser().email
        };
        return Object(__WEBPACK_IMPORTED_MODULE_17__firebase_util__["extend"])(saveData, extraData);
      }
    },
    getQuestionListData: function getQuestionListData() {
      return {
        'data': this.$root.surveyQuestions,
        'filterableFields': ['title']
      };
    },
    getData: function getData(target) {
      return {
        'data': this.$root[target],
        'filterableFields': ['title']
      };
    },
    deletePointKey: function deletePointKey(array) {
      var ro = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(array), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          var kq = k['.key'];
          ro[kq] = k;
          delete ro[kq]['.key'];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return ro;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  firebase: {
    users: dbDashboardApp.ref('users').orderByChild('name'),
    log: dbDashboardApp.ref('log').orderByChild('created_at'),
    surveyCampaigns: {
      source: dbDashboardApp.ref('survey/campaigns').orderByChild('created_at'),
      cancelCallback: function cancelCallback(err) {
        if (this.isNotNullorUndefined(err)) {
          this.launchToast(err.message, 'error');
        }
      }
    },
    surveyQuestions: {
      source: dbDashboardApp.ref('survey/questions').orderByChild('name'),
      cancelCallback: function cancelCallback(err) {
        if (this.isNotNullorUndefined(err)) {
          this.launchToast(err.message, 'error');
        }
      }
    }
  },
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "NPbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("3Alh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_53b7dcea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("aaHf");
function injectStyle (ssrContext) {
  __webpack_require__("rSdb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53b7dcea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_53b7dcea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NgTC":
/***/ (function(module, exports) {

module.exports = {"commonWords":{},"auth":{"agree":"Tôi đồng ý với","alreadyJoined":"Đã tham gia?","createAccount":"Tạo tài khoản","createNewAccount":"Tạo tài khoản mới","email":"Email","login":"Đăng nhập","password":"Mật mã","signUp":"Đăng kí","termsOfUse":"Điều khoản sử dụng.","welcome":"Chào mừng!"},"breadcrumbs":{"home":"Trang chủ"},"buttons":{"advanced":"Icons, Groups, Dropdowns","button":"BUTTON","colors":"Colors","disabled":"DISABLED","dropdown":"DROPDOWN","hover":"HOVER","main":"Primary & Secondary Buttons","micro":"MICRO","pressed":"PRESSED","small":"SMALL","add":"THÊM"},"charts":{"horizontalBarChart":"Horizontal Bar Chart","verticalBarChart":"Vertical Bar Chart","lineChart":"Line Chart","pieChart":"Pie Chart","donutChart":"Donut Chart","bubbleChart":"Bubble Chart"},"dashboard":{"dataVisualization":"Data Visualization","success":"THÀNH CÔNG","successMessage":"You successfully read this important alert message.","elements":"Thành phần","features":"Tính năng","setupProfile":"Thiết lập hồ sơ cá nhân","teamMembers":"Team Members","usersAndMembers":"Users & Members","versions":"Phiên bản"},"survey":{"success":"THÀNH CÔNG","successMessage":"You successfully read this important alert message.","elements":"Thành phần","teamMembers":"Team Members","versions":"Phiên bản","questionsList":"Danh sách câu hỏi","add":"Thêm","log":"Nhật ký","confirm":"Xác Nhận","confirmStep":"Bước 4. Xác nhận","addQuestions":{"questionType":"Loại","questionTitle":"Câu hỏi","questionOption":"Câu trả lời","questionConfirmAdd":"Xác nhận","stepOne":"Bước 1. Loại","stepTwo":"Bước 2. Câu hỏi","stepThree":"Bước 3. Câu trả lời","stepFour":"Bước 4. Xác nhận","typeChoice":"Chọn loại câu hỏi","enterTitle":"Câu hỏi mà bạn muốn đặt","enterOptions":"Thêm phương án cho câu hỏi.","optionsNoNeed":"Không cần thêm phương án cho loại câu hỏi này.","confirmText":"Sau bước xác nhận, bạn không thể thay đổi thể loại câu hỏi nữa. Bấm nút xác nhận để thêm câu hỏi vào danh sách."},"addCampaigns":{"campaignTitle":"Tên Chiến Dịch","campaignQuestions":"Danh Sách Câu Hỏi","campaignQuestionOrder":"Thứ Tự Câu Hỏi","stepOne":"Bước 1. Tên Chiến Dịch","stepTwo":"Bước 2. Danh Sách Câu Hỏi","stepThree":"Bước 3. Thứ Tự Câu Hỏi","enterTitle":"Enter the title for the campaign.","questionsChoice":"Choose the questions for this campaign.","enterOrder":"Choose the order for the questions. Start by 1. (Optional)","confirmText":"By adding this campaign, you can't edit anymore. Click 'Confirm' to add the campaign to the list."}},"notificationsPage":{"alerts":{"title":"Alerts","success":"SUCCESS","successMessage":"You successfully read this important alert message.","info":"INFO","infoMessage":"This alert needs your attention, but it's not super important.","warning":"WARNING","warningMessage":"Better check yourself, you're not looking too good.","danger":"DANGER","dangerMessage":"Change a few things up and try submitting again."},"popovers":{"title":"Tooltips & Popovers","popoverTitleLabel":"Popover Title","popoverTextLabel":"Popover Text","popoverIconLabel":"Popover Icon (fontawesome)","showPopover":"Show Popover","topTooltip":"top tooltip","rightTooltip":"rightside tooltip","leftTooltip":"left","bottomTooltip":"below"},"toasts":{"title":"Toasts","textLabel":"Text","durationLabel":"Duration (milliseconds)","iconLabel":"Icon (fontawesome)","fullWidthLabel":"Fullwidth","launchToast":"Launch toast"}},"extra":{"tabs":{"title":"Tabs","maps":"Maps","overview":"Overview","setupProfile":"Setup Profile"},"chat":"Chat","profileCard":"Profile Card"},"forms":{"controls":{"female":"Female","male":"Male","title":"Checkboxes, Radios, Switches","radioDisabled":"Disabled Radio","radio":"Radio","subscribe":"Subscribe to newsletter"},"dateTimePicker":{"title":"Date time pickers","basic":"Basic","time":"Time","range":"Range","multiple":"Multiple","disabled":"Disabled"},"inputs":{"emailValidatedSuccess":"Email (validated with success)","emailValidated":"Email (validated)","inputWithIcon":"Input With Icon","inputWithButton":"Input With Button","inputWithClearButton":"Input With Clear Button","inputWithRoundButton":"Input With Round Button","textInput":"Text Input","textInputWithDescription":"Text Input (with description)","textArea":"Text Area","title":"Inputs","upload":"UPLOAD"},"mediumEditor":{"title":"Medium Editor"},"selects":{"country":"Country Select","countryMulti":"Country Multi Select","multi":"Multi Select","simple":"Simple Select","title":"Selects"},"wizard":{"name":"Name","completed":"Wizard completed!","confirmSelection":"Confirm selection","rich":"Rich Wizard","simple":"Simple Wizard","stepOne":"Step 1. Name","stepTwo":"Step 2. Country","stepThree":"Step 3. Confirm","verticalRich":"Vertical Rich Wizard","verticalSimple":"Vertical Simple Wizard","completedWithError":"Lỗi, quy trình không thể hoàn thành!","completedWithSuccess":"Quy trình hoàn thành!","completedWithErrorDescription":"Lỗi xảy ra! Liên hệ với quản trị viên hoặc kiểm tra lại quy trình.","completedWithSuccessDescription":"Lưu thành công dữ liệu, chuyển hướng đến bước đầu tiên sau vài giây."}},"grid":{"desktop":"Desktop Grid","fixed":"Fixed Grid","offsets":"Offsets","responsive":"Responsive Grid"},"icons":{"back":"Back to icons","none":"No icons found","search":"Icon search","title":"Icons"},"spinners":{"title":"Spinners","poweredBy":"Powered by"},"language":{"english":"English","spanish":"Spanish","vietnamese":"Tiếng Việt"},"menu":{"auth":"Auth","buttons":"Buttons","charts":"Charts","dashboard":"Bảng điều khiển","survey":"Khảo sát","surveyQuestions":"Câu hỏi","surveyFeedbacks":"Phản hồi","surveyCampaigns":"Chiến dịch","settings":"Cài đặt","settingsGeneral":"Tổng hợp","settingsProjects":"Dự án","settingsUsers":"Người dùng","extra":"Phần phụ","forms":"Forms","formElements":"Form Elements","formWizards":"Form Wizards","mediumEditor":"Medium Editor","grid":"Grid","icons":"Icons","spinners":"Spinners","login":"Login","maps":"Maps","modals":"Modals","notifications":"Notifications","progressBars":"Progress Bars","signUp":"Sign up","statistics":"Statistics","tables":"Tables","typography":"Typography","uiElements":"UI Elements","treeView":"Tree view","dateTimePickers":"Date time pickers"},"messages":{"all":"Xem tất cả tin nhắn","new":"Tin nhắn mới từ {name}"},"modal":{"cancel":"HỦY","back":"QUAY LẠI","close":"ĐÓNG","confirm":"ĐỒNG Ý","save":"LƯU","confirmTitle":"Xác nhận","confirmQuitMessage":"Bạn có chắc chắn muốn thoát ?","removeTitle":"Xóa","removeMessage":"Bạn muốn xóa mục này ?","editTitle":"Sửa","large":"Large","largeTitle":"Large Modal","medium":"Medium","mediumTitle":"Medium Modal","small":"Small","smallTitle":"Small Modal","static":"Static","staticMessage":"This is a static modal, backdrop click will not close it.","staticTitle":"Static Modal","title":"Modals"},"navbar":{"messageUs":"Send us your questions or feedback to"},"notifications":{"all":"See all notifications","sentMessage":"{name} sent you a message","uploadedZip":"{name} uploaded a new Zip file with {type}","startedTopic":"{name} started a new topic"},"progressBars":{"basic":"Basic","basicVertical":"Basic Vertical","circle":"Circle","colorFulTitle":"Colorful Bars","thin":"Thin","thinVertical":"Thin Vertical","thick":"Thick","title":"Progress Bars"},"tables":{"basic":"Basic Table","styled":"Colors, Icons, Labels","advanced":"Search & Pagination","headings":{"city":"Thành Phố","email":"Email","name":"Tên","score":"Điểm số","time":"Thời gian","log":"Nhật kí"}},"user":{"language":"Đổi ngôn ngữ","logout":"Đăng xuất","profile":"Hồ sơ cá nhân của tôi"},"treeView":{"basic":"Basic","icons":"Icons","selectable":"Selectable","editable":"Editable","advanced":"Advanced"}}

/***/ }),

/***/ "NpL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "NruP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O5fT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var HORIZONTAL_LAYOUT = 'horizontal';
    var VERTICAL_LAYOUT = 'vertical';
    var initialLayout = binding.value.layout;
    var breakpoint = binding.value.breakPoint;

    var wizardLayout = initialLayout;

    var handleResize = function handleResize() {
      var width = window.innerWidth;
      var layout = width <= breakpoint ? HORIZONTAL_LAYOUT : VERTICAL_LAYOUT;
      if (wizardLayout !== layout) {
        wizardLayout = layout;
        vnode.context.$emit('wizardLayoutChange', wizardLayout);
      }
    };

    if (initialLayout === VERTICAL_LAYOUT) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
  }
});

/***/ }),

/***/ "OLG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.isBlocked",modifiers:{"isBlocked":true}}],staticClass:"form-group with-icon-right dropdown select-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"}],class:{'has-value': !!_vm.value},attrs:{"name":_vm.name,"options":_vm.options},domProps:{"value":(_vm.displayValue)},on:{"focus":function($event){_vm.showDropdown()},"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-arrow-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v("\n      "+_vm._s(_vm.showRequiredError())+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.filteredList),function(option){return _c('div',{staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.selectOption(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))])])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OPFe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__ = __webpack_require__("WHJM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bc132dda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__ = __webpack_require__("X4hv");
function injectStyle (ssrContext) {
  __webpack_require__("ghGU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc132dda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bc132dda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ORei":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OX+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__ = __webpack_require__("UBQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__ = __webpack_require__("K82C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__ = __webpack_require__("PKk7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__ = __webpack_require__("1mf5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__ = __webpack_require__("O5fT");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard',
  props: {
    steps: {},
    wizardType: {
      type: String,
      default: 'simple'
    },
    wizardLayout: {
      type: String,
      default: 'horizontal'
    },
    lastStepLabel: { default: 'Confirm' },
    onNext: {},
    onBack: {}
  },
  data: function data() {
    return {
      currentStep: 0,
      wizardCompleted: false,
      wizardCompletedSlotName: 'wizardCompleted',
      orientationBreakPoint: 767,
      computedLayout: this.wizardLayout
    };
  },

  components: {
    SimpleHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__["a" /* default */],
    RichHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__["a" /* default */],
    RichVerticalIndicator: __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__["a" /* default */],
    SimpleVerticalIndicator: __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__["a" /* default */]
  },
  directives: {
    orientationHandler: __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__["a" /* default */]
  },
  computed: {
    currentSlot: function currentSlot() {
      var slotName = this.steps[this.currentStep].slot;
      if (this.wizardCompleted) {
        slotName = this.wizardCompletedSlotName;
      }
      return slotName;
    },
    backEnabled: function backEnabled() {
      return this.currentStep !== 0;
    }
  },
  created: function created() {
    this.$on('wizardLayoutChange', this.updateLayout);
  },

  methods: {
    updateLayout: function updateLayout(layout) {
      this.computedLayout = layout;
    },
    goNext: function goNext() {
      this.currentStepOnNext();
      if (!this.isLastStep() && this.isCurrentStepValid()) {
        this.currentStep++;
      }
    },
    goBack: function goBack() {
      this.currentStepOnBack();
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    isConfirmWizard: function isConfirmWizard() {
      var _this = this;

      this.currentStepOnNext();
      if (this.isLastStep() && this.isCurrentStepValid()) {
        this.completeWizard();
        setTimeout(function () {
          _this.resetWizard();
        }, 3000);
      }
    },
    completeWizard: function completeWizard() {
      this.wizardCompleted = true;
      this.$emit('wizardComplete');
      this.goNext();
    },
    isLastStep: function isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
    currentStepOnNext: function currentStepOnNext() {
      var step = this.steps[this.currentStep];
      if (step.onNext) {
        step.onNext();
      }
    },
    currentStepOnBack: function currentStepOnBack() {
      var step = this.steps[this.currentStep];
      if (step.onBack) {
        step.onBack();
      }
    },
    isCurrentStepValid: function isCurrentStepValid() {
      return this.steps[this.currentStep].isValid();
    },
    isStepShown: function isStepShown(step) {
      return step.slot === this.currentSlot && !this.wizardCompleted;
    },
    resetWizard: function resetWizard() {
      this.currentStep = 0;
      this.wizardCompleted = false;
      this.$emit('wizardReset');
    }
  }
});

/***/ }),

/***/ "OzOB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P+0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_editor__ = __webpack_require__("kLCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_medium_editor__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-medium-editor',

  props: {
    editorOptions: {
      type: Object,
      default: function _default() {
        return {
          buttonLabels: 'fontawesome',
          autoLink: true,
          toolbar: {
            buttons: ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3']
          }
        };
      }
    }
  },

  data: function data() {
    return {
      editor: null
    };
  },
  mounted: function mounted() {
    this.initEditor();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyEditor();
  },


  methods: {
    initEditor: function initEditor() {
      this.editor = new __WEBPACK_IMPORTED_MODULE_0_medium_editor___default.a(this.$el, this.editorOptions);
      this.$emit('initialized', this.editor);
    },
    destroyEditor: function destroyEditor() {
      this.editor.destroy();
    }
  }
});

/***/ }),

/***/ "PKk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__ = __webpack_require__("+tWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb1c143_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__ = __webpack_require__("d2lb");
function injectStyle (ssrContext) {
  __webpack_require__("vd+D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bb1c143"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb1c143_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PLt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuestic-navbar',[_c('header-selector',{attrs:{"slot":"selector","isOpen":_vm.valueProxy},on:{"update:isOpen":function($event){_vm.valueProxy=$event}},slot:"selector"}),_vm._v(" "),_c('span',{staticClass:"i-vuestic-stsc-long",attrs:{"slot":"logo"},slot:"logo"}),_vm._v(" "),_c('message-dropdown'),_vm._v(" "),_c('notification-dropdown'),_vm._v(" "),_c('language-dropdown'),_vm._v(" "),_c('profile-dropdown',[_c('img',{attrs:{"src":"/static/img/avatars/011-dragon-1.png"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PcFD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoaderSTSC_vue__ = __webpack_require__("nolp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2761b83a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoaderSTSC_vue__ = __webpack_require__("08VY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoaderSTSC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2761b83a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoaderSTSC_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q3Vu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sidebar-link"},[_c('router-link',{staticClass:"sidebar-link__router-link",attrs:{"to":_vm.to,"target":"_self"}},[_vm._t("title")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QcUt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qci5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qgdr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qlvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AuthLayout'
});

/***/ }),

/***/ "Qx7w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner"},[_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-circle",style:(_vm.circleStyle)},[_vm._v("\n      ●\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RLg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__ = __webpack_require__("VLQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_db27c0ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__ = __webpack_require__("Qx7w");
function injectStyle (ssrContext) {
  __webpack_require__("SodH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db27c0ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_db27c0ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rubq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderSelector_vue__ = __webpack_require__("3Cfn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efb31872_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderSelector_vue__ = __webpack_require__("SQAr");
function injectStyle (ssrContext) {
  __webpack_require__("Xn4C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efb31872_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "S0Tt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDatePicker_vue__ = __webpack_require__("x4Yd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_526c1f28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDatePicker_vue__ = __webpack_require__("LLbi");
function injectStyle (ssrContext) {
  __webpack_require__("Qci5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_526c1f28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SQAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"header-selector",class:{ 'i-menu-expanded': !_vm.isOpen, 'i-menu-collapsed': _vm.isOpen },on:{"click":function($event){_vm.$emit('update:isOpen', !_vm.isOpen)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "STeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal"},[(_vm.size != 'thick')?_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('width: ' + _vm.value + '%')},[(_vm.size == 'thick')?_c('span',{staticClass:"value",class:{hidden: _vm.animatedValue == _vm.min}},[_vm._v("\n        "+_vm._s(_vm.animatedValue + '%')+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SVED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-data-table table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column align-items-center",class:_vm.controlsAlignmentClass},[_c('filter-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.filterInputShown),expression:"filterInputShown"}],attrs:{"label":_vm.filterInputLabel},on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('div',{staticClass:"datatable-controls d-flex flex-row"},[_c('div',{staticClass:"form-group"},[_vm._t("additionalTableControl")],2),_vm._v(" "),_c('items-per-page',{directives:[{name:"show",rawName:"v-show",value:(_vm.perPageSelectorShown),expression:"perPageSelectorShown"}],attrs:{"options":_vm.itemsPerPage,"label":_vm.itemsPerPageLabel,"defaultPerPage":_vm.defaultPerPageComputed},on:{"items-per-page":_vm.onItemsPerPage}})],1)],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"httpFetch":_vm.httpFetch,"httpOptions":_vm.httpOptions,"fields":_vm.tableFields,"dataManager":_vm.dataManager,"css":_vm.css.table,"dataPath":"data","paginationPath":_vm.paginationPathComputed,"appendParams":_vm.moreParams,"perPage":_vm.perPage,"queryParams":_vm.queryParams},on:{"vuetable:pagination-data":_vm.onPaginationData}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SZ1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__ = __webpack_require__("M975");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_827bef1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__ = __webpack_require__("Q3Vu");
function injectStyle (ssrContext) {
  __webpack_require__("QcUt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_827bef1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Shux":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SodH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T/73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hollow-dots-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.dotsStyles),function(ds,index){return _c('div',{key:index,staticClass:"dot",style:(ds)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T7Ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("+s3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e43772ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("rvkD");
function injectStyle (ssrContext) {
  __webpack_require__("7mhP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e43772ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e43772ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TLp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_theme_vuestic_components_vuestic_navbar_VuesticNavbar__ = __webpack_require__("2XLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderSelector__ = __webpack_require__("Rubq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dropdowns_LanguageDropdown__ = __webpack_require__("CqZu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dropdowns_ProfileDropdown__ = __webpack_require__("eOY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dropdowns_NotificationDropdown__ = __webpack_require__("sWYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dropdowns_MessageDropdown__ = __webpack_require__("HouA");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-navbar',

  components: {
    VuesticNavbar: __WEBPACK_IMPORTED_MODULE_0__vuestic_theme_vuestic_components_vuestic_navbar_VuesticNavbar__["a" /* default */],
    HeaderSelector: __WEBPACK_IMPORTED_MODULE_1__components_HeaderSelector__["default"],
    MessageDropdown: __WEBPACK_IMPORTED_MODULE_5__components_dropdowns_MessageDropdown__["default"],
    NotificationDropdown: __WEBPACK_IMPORTED_MODULE_4__components_dropdowns_NotificationDropdown__["default"],
    LanguageDropdown: __WEBPACK_IMPORTED_MODULE_2__components_dropdowns_LanguageDropdown__["default"],
    ProfileDropdown: __WEBPACK_IMPORTED_MODULE_3__components_dropdowns_ProfileDropdown__["default"]
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    valueProxy: {
      get: function get() {
        return this.isOpen;
      },
      set: function set(opened) {
        this.$emit('toggle-menu', opened);
      }
    }
  }
});

/***/ }),

/***/ "TUXY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__ = __webpack_require__("Z5WX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284a7efd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__ = __webpack_require__("oLtg");
function injectStyle (ssrContext) {
  __webpack_require__("/5zc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284a7efd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TqEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cp, _this.circleStyle);
      });
    }
  }
});

/***/ }),

/***/ "U2Zt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  bind: function bind(el, binding) {
    var dropdownToggle = el.querySelector('.dropdown-toggle');
    var dropdownToggleInput = el.querySelector('.dropdown-toggle input');
    var dropdownMenu = el.querySelector('.dropdown-menu');
    var dropdownItem = el.querySelector('.dropdown-menu-content');
    var dropdownIon = el.querySelector('.ion');
    var closeOnMenuClick = binding.modifiers.closeOnMenuClick;
    var isBlocked = binding.modifiers.isBlocked;

    dropdownToggle.addEventListener('click', function (event) {
      event.preventDefault();
      var isShown = el.classList.contains('show');
      setTimeout(function () {
        if (isBlocked) {
          if (!isShown) {
            dropdownIon.classList.add('ion-ios-arrow-up');
            el.classList.toggle('show', !isShown);
            dropdownMenu.classList.toggle('show', !isShown);
          }
        } else {
          el.classList.toggle('show', !isShown);
          dropdownMenu.classList.toggle('show', !isShown);
        }
      });
    });

    el.removeShow = function (event) {
      if (event.target !== dropdownToggleInput) {
        if (dropdownIon) {
          if (dropdownIon.classList.contains('ion-ios-arrow-up')) {
            dropdownIon.classList.remove('ion-ios-arrow-up');
          }
        }
        el.classList.remove('show');
        dropdownMenu.classList.remove('show');
      }
    };

    window.addEventListener('click', el.removeShow);

    dropdownMenu.addEventListener('click', function (evt) {
      if (!closeOnMenuClick) {
        evt.stopPropagation();
      }
    });

    if (dropdownItem) {
      dropdownItem.addEventListener('click', function () {
        if (dropdownIon) {
          if (dropdownIon.classList.contains('ion-ios-arrow-up')) {
            dropdownIon.classList.remove('ion-ios-arrow-up');
          }
        }
        if (!binding.arg === 'focus') {
          dropdownMenu.classList.remove('show');
          el.classList.remove('show');
        }
      });
    }
  },

  unbind: function unbind(el) {
    window.removeEventListener('click', el.removeShow);
  }
});

/***/ }),

/***/ "UBQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("IQ8j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011a55bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("jpRP");
function injectStyle (ssrContext) {
  __webpack_require__("JoHn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-011a55bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011a55bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UW5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__ = __webpack_require__("H65f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6abfee3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__ = __webpack_require__("+ihS");
function injectStyle (ssrContext) {
  __webpack_require__("6ev5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6abfee3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6abfee3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleWithoutAnimation", function() { return toggleWithoutAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebarOpened", function() { return sidebarOpened; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "palette", function() { return palette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
var sidebarOpened = function sidebarOpened(state) {
  return state.app.sidebar.opened;
};
var toggleWithoutAnimation = function toggleWithoutAnimation(state) {
  return state.app.sidebar.withoutAnimation;
};
var config = function config(state) {
  return state.app.config;
};
var palette = function palette(state) {
  return state.app.config.palette;
};
var isLoading = function isLoading(state) {
  return state.app.isLoading;
};



/***/ }),

/***/ "UpdR":
/***/ (function(module, exports) {

module.exports = {"commonWords":{},"auth":{"agree":"I agree to","alreadyJoined":"Already joined?","createAccount":"Create account","createNewAccount":"Create account","email":"Email","login":"Login","password":"Password","signUp":"Sign Up","termsOfUse":"Terms of Use.","welcome":"Welcome!"},"breadcrumbs":{"home":"Home"},"buttons":{"advanced":"Icons, Groups, Dropdowns","button":"BUTTON","colors":"Colors","disabled":"DISABLED","dropdown":"DROPDOWN","hover":"HOVER","main":"Primary & Secondary Buttons","micro":"MICRO","pressed":"PRESSED","small":"SMALL","add":"ADD","save":"SAVE"},"charts":{"horizontalBarChart":"Horizontal Bar Chart","verticalBarChart":"Vertical Bar Chart","lineChart":"Line Chart","pieChart":"Pie Chart","donutChart":"Donut Chart","bubbleChart":"Bubble Chart"},"dashboard":{"dataVisualization":"Data Visualization","success":"SUCCESS","successMessage":"You successfully read this important alert message.","elements":"Elements","features":"Features","setupProfile":"Setup Profile","teamMembers":"Team Members","usersAndMembers":"Users & Members","versions":"Versions"},"survey":{"success":"SUCCESS","successMessage":"You successfully read this important alert message.","elements":"Elements","versions":"Versions","teamMembers":"Team Members","questionsList":"Questions List","campaignsList":"Campaigns List","add":"Add","order":"Order","log":"Log","confirm":"Confirm","confirmStep":"Step 4. Confirm","statistics":"Statistics","addQuestions":{"questionType":"Type","questionTitle":"Title","questionOption":"Option","questionConfirmAdd":"Confirm","stepOne":"Step 1. Type","stepTwo":"Step 2. Title","stepThree":"Step 3. Options","stepFour":"Step 4. Confirm","typeChoice":"Choose the type of the question.","enterTitle":"Enter the title for the question.","enterOptions":"Add some option for the question.","optionsNoNeed":"No need to add the options for this question type.","confirmText":"By adding this question, you can't change anymore its type. Click 'Confirm' to add the question to the list."},"addCampaigns":{"campaignTitle":"Campaign Title","campaignQuestions":"Questions List","campaignQuestionOrder":"Question Order","stepOne":"Step 1. Title","stepTwo":"Step 2. Questions","stepThree":"Step 3. Question Order","stepFour":"Step 4. Confirm","enterTitle":"Enter the title for this campaign.","questionsChoice":"Choose the questions for this campaign.","enterOrder":"Choose the order for the questions. Start by 1. (Optional)","confirmText":"By adding this campaign, you can't edit anymore. Click 'Confirm' to add the campaign to the list."}},"notificationsPage":{"alerts":{"title":"Alerts","success":"SUCCESS","successMessage":"You successfully read this important alert message.","info":"INFO","infoMessage":"This alert needs your attention, but it's not super important.","warning":"WARNING","warningMessage":"Better check yourself, you're not looking too good.","danger":"DANGER","dangerMessage":"Change a few things up and try submitting again."},"popovers":{"title":"Tooltips & Popovers","popoverTitleLabel":"Popover Title","popoverTextLabel":"Popover Text","popoverIconLabel":"Popover Icon (fontawesome)","showPopover":"Show Popover","topTooltip":"top tooltip","rightTooltip":"rightside tooltip","leftTooltip":"left","bottomTooltip":"below"},"toasts":{"title":"Toasts","textLabel":"Text","durationLabel":"Duration (milliseconds)","iconLabel":"Icon (fontawesome)","fullWidthLabel":"Fullwidth","launchToast":"Launch toast"}},"extra":{"tabs":{"title":"Tabs","maps":"Maps","overview":"Overview","setupProfile":"Setup Profile"},"chat":"Chat","profileCard":"Profile Card"},"forms":{"controls":{"female":"Female","male":"Male","title":"Checkboxes, Radios, Switches","radioDisabled":"Disabled Radio","radio":"Radio","subscribe":"Subscribe to newsletter"},"dateTimePicker":{"title":"Date time pickers","basic":"Basic","time":"Time","range":"Range","multiple":"Multiple","disabled":"Disabled"},"inputs":{"emailValidatedSuccess":"Email (validated with success)","emailValidated":"Email (validated)","inputWithIcon":"Input With Icon","inputWithButton":"Input With Button","inputWithClearButton":"Input With Clear Button","inputWithRoundButton":"Input With Round Button","textInput":"Text Input","textInputWithDescription":"Text Input (with description)","textArea":"Text Area","title":"Inputs","upload":"UPLOAD"},"mediumEditor":{"title":"Medium Editor"},"selects":{"country":"Country Select","countryMulti":"Country Multi Select","multi":"Multi Select","simple":"Simple Select","title":"Selects"},"wizard":{"name":"Name","completed":"Wizard completed!","confirmSelection":"Confirm selection","rich":"Rich Wizard","simple":"Simple Wizard","stepOne":"Step 1. Name","stepTwo":"Step 2. Country","stepThree":"Step 3. Confirm","verticalRich":"Vertical Rich Wizard","verticalSimple":"Vertical Simple Wizard","completedWithError":"Error, the process can not complete!","completedWithSuccess":"Process completed!","completedWithErrorDescription":"Errors occur! Contact an admin or recheck the process.","completedWithSuccessDescription":"Successfully save the data, redirect to first step after few seconds."}},"grid":{"desktop":"Desktop Grid","fixed":"Fixed Grid","offsets":"Offsets","responsive":"Responsive Grid"},"icons":{"back":"Back to icons","none":"No icons found","search":"Icon search","title":"Icons"},"spinners":{"title":"Spinners","poweredBy":"Powered by"},"language":{"english":"English","vietnamese":"Vietnamese","spanish":"Spanish"},"menu":{"auth":"Auth","buttons":"Buttons","charts":"Charts","dashboard":"Dashboard","survey":"Survey","surveyQuestions":"Questions","surveyFeedbacks":"Feedbacks","surveyCampaigns":"Campaigns","settings":"Settings","settingsGeneral":"General","settingsProjects":"Projects","settingsUsers":"Users","extra":"Extra","forms":"Forms","formElements":"Form Elements","formWizards":"Form Wizards","mediumEditor":"Medium Editor","grid":"Grid","icons":"Icons","spinners":"Spinners","login":"Login","maps":"Maps","modals":"Modals","notifications":"Notifications","progressBars":"Progress Bars","signUp":"Sign up","statistics":"Statistics","tables":"Tables","typography":"Typography","uiElements":"UI Elements","treeView":"Tree view","dateTimePickers":"Date time pickers"},"messages":{"all":"See all messages","new":"New messages from {name}"},"modal":{"cancel":"CANCEL","back":"BACK","close":"CLOSE","confirm":"CONFIRM","save":"SAVE","confirmTitle":"Confirm","confirmQuitMessage":"Are you sure to quit ?","removeTitle":"Remove","removeMessage":"Are you sure to remove this item ?","editTitle":"Edit","large":"Large","largeTitle":"Large Modal","medium":"Medium","mediumTitle":"Medium Modal","small":"Small","smallTitle":"Small Modal","static":"Static","staticMessage":"This is a static modal, backdrop click will not close it.","staticTitle":"Static Modal","title":"Modals"},"navbar":{"messageUs":"Send us your questions or feedback to"},"notifications":{"all":"See all notifications","sentMessage":"{name} sent you a message","uploadedZip":"{name} uploaded a new Zip file with {type}","startedTopic":"{name} started a new topic"},"progressBars":{"basic":"Basic","basicVertical":"Basic Vertical","circle":"Circle","colorFulTitle":"Colorful Bars","thin":"Thin","thinVertical":"Thin Vertical","thick":"Thick","title":"Progress Bars"},"tables":{"basic":"Basic Table","styled":"Colors, Icons, Labels","advanced":"Search & Pagination","headings":{"city":"City","email":"Email","name":"Name","score":"Score","time":"Time","log":"Log"}},"user":{"language":"Change Language","logout":"Logout","profile":"My Profile"},"treeView":{"basic":"Basic","icons":"Icons","selectable":"Selectable","editable":"Editable","advanced":"Advanced"}}

/***/ }),

/***/ "V6Tn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-pre-loader"},[_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VFNt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VLQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: 'red'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "Vfss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-bouncing-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle",style:(_vm.circleStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VoWT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__ = __webpack_require__("s+US");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaa48b6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__ = __webpack_require__("g5S/");
function injectStyle (ssrContext) {
  __webpack_require__("epoO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaa48b6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W3ZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__ = __webpack_require__("oKE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ceed852_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__ = __webpack_require__("bFyO");
function injectStyle (ssrContext) {
  __webpack_require__("hvgk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ceed852_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WHJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),

/***/ "WOMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Doughnut"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp],
  props: ['chartData', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.chartData, options);
  }
}));

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var state = {
  sidebar: {
    opened: false,
    withoutAnimation: false
  },
  config: {
    googleMaps: {
      apiKey: 'AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ'
    },
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd'
    }
  },
  isLoading: true
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLOSE_MENU */], function (state) {
  if (document.documentElement.clientWidth < 992) {
    state.sidebar.opened = false;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_SIDEBAR */], function (state, opened) {
  state.sidebar.opened = opened;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* TOGGLE_WITHOUT_ANIMATION */], function (state, value) {
  state.sidebar.withoutAnimation = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'setLoading', function setLoading(state, isLoading) {
  state.isLoading = isLoading;
}), _mutations);

var actions = {
  closeMenu: function closeMenu(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLOSE_MENU */]);
  },
  toggleSidebar: function toggleSidebar(_ref2, opened) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_SIDEBAR */], opened);
  },
  isToggleWithoutAnimation: function isToggleWithoutAnimation(_ref3, value) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* TOGGLE_WITHOUT_ANIMATION */], value);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "WScA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WXh0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_vue__ = __webpack_require__("3VgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c8429a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_vue__ = __webpack_require__("BQX4");
function injectStyle (ssrContext) {
  __webpack_require__("Shux")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c8429a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wg4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message-dropdown',

  props: {
    options: {
      type: Array,
      default: function _default() {
        return [{
          name: 'new',
          details: { name: 'Oleg M' }
        }, {
          name: 'new',
          details: { name: 'Andrei H' }
        }];
      }
    }
  }
});

/***/ }),

/***/ "WlTu":
/***/ (function(module, exports) {

module.exports = {"commonWords":{},"auth":{"agree":"Acepto","alreadyJoined":"Ya tienes una cuenta?","createAccount":"Create cuenta","createNewAccount":"Crear cuenta","email":"Email","login":"Iniciar sesión","password":"Contraseña","signUp":"Registrar","termsOfUse":"Los terminos de uso","welcome":"Bienvenido!"},"buttons":{"advanced":"Iconos, Grupos, Dropdowns","button":"BOTON","colors":"Colores","disabled":"DESHABILITADO","dropdown":"DESPLEGABLE","hover":"HOVER","main":"Botón Primario y Secundario","micro":"MICRO","pressed":"PRESIONADO","small":"PEQUEÑO","add":"AÑADIR"},"charts":{"bubbleChart":"Bubble Chart","donutChart":"Donut Chart","horizontalBarChart":"Horizontal Bar Chart","lineChart":"Line Chart","pieChart":"Pie Chart","verticalBarChart":"Vertical Bar Chart"},"dashboard":{"elements":"Elementos","success":"ÉXITO","successMessage":"Ha leído correctamente este mensaje de alerta importante.","teamMembers":"Miembros del Equipo","versions":"Versiones"},"survey":{"success":"ÉXITO","successMessage":"Ha leído correctamente este mensaje de alerta importante.","elements":"Elementos","versions":"Versiones","questionsList":"Lista de preguntas","addEdit":"Agregar","log":"Log","confirm":"Confirmar","confirmStep":"Paso 4. Confirmar","addQuestions":{"questionType":"Tipo","questionTitle":"Título","questionOption":"Opción","questionConfirmAdd":"Confirmar","stepOne":"Paso 1. Tipo","stepTwo":"Paso 2. Título","stepThree":"Paso 3. Opciones","stepFour":"Paso 4. Confirmar","typeChoice":"Elija el tipo de pregunta.","enterTitle":"Ingrese el título de la pregunta.","enterOptions":"Agregue alguna opción a la pregunta.","optionsNoNeed":"No es necesario agregar las opciones para este tipo de pregunta.","confirmText":" Al agregar esta pregunta, ya no puede cambiar su tipo. Haga clic en 'Confirmar' para agregar la pregunta a la lista."},"addCampaigns":{"campaignTitle":"Campaign Title","campaignQuestions":"Questions List","campaignQuestionOrder":"Question Order","stepOne":"Step 1. Title","stepTwo":"Step 2. Questions","stepThree":"Step 3. Question Order","stepFour":"Step 4. Confirm","enterTitle":"Enter the title for the campaign.","questionsChoice":"Choose the questions for this campaign.","enterOrder":"Choose the order for the questions. Start by 1. (Optional)","confirmText":"By adding this campaign, you can't edit anymore. Click 'Confirm' to add the campaign to the list."}},"notificationsPage":{"alerts":{"title":"Alerts","success":"ÉXITO","successMessage":"Ha leído correctamente este mensaje de alerta importante.","info":"INFO","infoMessage":"Esta alerta necesita tu atención, pero no es muy importante.","warning":"ADVERTENCIA","warningMessage":"Mejor compruébalo, esto no pinta bien.","danger":"PELIGRO","dangerMessage":"Cambiar algunas cosas e enviarlo de nuevo."},"popovers":{"title":"Tooltips & Popovers","popoverTitleLabel":"Title de Popover","popoverTextLabel":"Texto de Popover","popoverIconLabel":"Icono de Popover (fontawesome)","showPopover":"Mostrar Popover","topTooltip":"tope tooltip","rightTooltip":"derecha tooltip","leftTooltip":"izquierda","bottomTooltip":"fondo"},"Toasts":{"title":"tostadas","textLabel":"Texto","durationLabel":"Duración (milisegundos)","iconLabel":"Icono (fontawesome)","fullWidthLabel":"Ancho total","launchToast":"Lanzar tostadas"}},"extra":{"tabs":{"title":"Tabs","maps":"Mapas","overview":"Visión de conjunto","setupProfile":"Perfil de Configuración"},"chat":"Chat","profileCard":"Tarjeta de Perfil"},"forms":{"controls":{"female":"Mujer","male":"Hombre","title":"Checkboxes, Radios, Switches","radioDisabled":"Radio Desactivado","radio":"Radio","subscribe":"Suscribirse a la newsletter"},"inputs":{"emailValidatedSuccess":"Email (validado con éxito)","emailValidated":"Email (validado)","inputWithIcon":"Input con Icono","inputWithButton":"Input con Boton","inputWithClearButton":"Input With Clear Button","inputWithRoundButton":"Input With Round Button","textInput":"Input de Texto","textInputWithDescription":"Input de Texto (con descripcion)","textArea":"Text Area","title":"Inputs","upload":"SUBIR"},"mediumEditor":{"title":"Medium Editor"},"selects":{"country":"País Select","countryMulti":"País Multi Select","multi":"Multi Select","simple":"Select Simple","title":"Selects"},"wizard":{"completed":"Asistente Completado!","confirmSelection":"Confirmar selección","name":"Nombre","rich":"Asistente Rico","simple":"Asistente Simple","stepOne":"Step 1. Nombre","stepTwo":"Step 2. País","stepThree":"Step 3. Confirmar","verticalRich":"Asistente Rico Vertical","verticalSimple":"Asistente Simple Vertical","completedWithError":"¡Errores, el proceso no puede completar!","completedWithSuccess":"¡Proceso completado!","completedWithErrorDescription":"¡Ocurren errores! Póngase en contacto con un administrador o vuelva a verificar el proceso.","completedWithSuccessDescription":"Guarde con éxito los datos, redirija al primer paso después de unos segundos."}},"grid":{"fixed":"Grid Fijo","desktop":"Desktop Grid","responsive":"Responsive Grid","offsets":"Offsets"},"icons":{"back":"Volver a los iconos","none":"No se han encontrado iconos","search":"Búsqueda de iconos","title":"Iconos"},"language":{"english":"Ingles","spanish":"Español","vietnamese":"vietnamita"},"menu":{"auth":"Autenticación","buttons":"Botones","charts":"Gráficos","dashboard":"Dashboard","survey":"Encuesta","surveyQuestions":"Preguntas","surveyFeedbacks":"Retroalimentaciones","surveyFeedbackers":"Campañas","settings":"Ajustes","settingsGeneral":"General","settingsProjects":"Proyectos","settingsUsers":"Usuarios","extra":"Extra","formElements":"Elementos de un Formulario","forms":"Formularios","formWizards":"Asistente para Formularios","mediumEditor":"Medium Editor","grid":"Grid","icons":"Iconos","login":"Iniciar sesión","maps":"Mapas","modals":"Modals","notifications":"Notificaciones","progressBars":"Barras de Progreso","signUp":"Registrar","statistics":"Estadisticas","tables":"Tablas","typography":"Tipografía","uiElements":"Elementos UI"},"messages":{"all":"Ver todos los mensajes","new":"Nuevo mensajes de {name}"},"modal":{"cancel":"CANCELAR","back":"ESPALDA","close":"CERRAR","confirm":"CONFIRMAR","confirmTitle":"Confirmar","save":"SALVAR","confirmQuitMessage":"¿Estás seguro de dejarlo?","removeTitle":"Retirar","removeMessage":"¿Estás seguro de eliminar este artículo?","editTitle":"Editar","large":"Largo","largeTitle":"Modal Largo","medium":"Mediano","mediumTitle":"Modal Mediana","small":"Pequeño","static":"Estático","smallTitle":"Modal Pequeña","staticMessage":"Esto es un modal estático. No se cerrará haciendo clic en el fondo.","staticTitle":"Modal Estático","title":"Modals"},"navbar":{"messageUs":"Envíenos sus preguntas o comentarios a"},"notifications":{"all":"Ver todos los notificaciones","sentMessage":"{name} te ha mandado un mensaje","uploadedZip":"{name} ha subido un archivo Zip con {type}","startedTopic":"{name} ha creado una tema nueva"},"progressBars":{"basic":"Basico","basicVertical":"Basico y Vertical","circle":"Circular","colorFulTitle":"Barras Coloridas","thin":"Delgado","thinVertical":"Delgado Vertical","thick":"Grueso","title":"Barras de Progresso"},"tables":{"basic":"Tabla basica","styled":"Colores, Iconos, Etiquetas","advanced":"Búsqueda y Paginación","headings":{"city":"Ciudad","email":"Email","name":"Nombre","score":"Puntuación","time":"Hora","log":"Iniciar sesión"}},"user":{"language":"Cambiar Idioma","profile":"Mi Perfil","logout":"Cerrar Sesión"}}

/***/ }),

/***/ "WmOq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFixedHeader)?_c('div',[_c('div',{staticClass:"vuetable-head-wrapper"},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{key:fieldIndex,class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{key:fieldIndex,class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{key:fieldIndex,class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{key:fieldIndex,class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]}),_vm._v(" "),(_vm.scrollVisible)?_c('th',{staticClass:"vuetable-gutter-col",style:({width: _vm.scrollBarWidth})}):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"vuetable-body-wrapper",style:({height: _vm.tableHeight})},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]},[_c('colgroup',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[_c('col',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass],style:({width: field.width}),attrs:{"id":'_col_' + field.name}})]:_vm._e()]})],2),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,itemIndex){return [_c('tr',{key:itemIndex,class:_vm.onRowClass(item, itemIndex),attrs:{"item-index":itemIndex,"render":_vm.onRowChanged(item)},on:{"click":function($event){_vm.onRowClicked(item, $event)},"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{key:fieldIndex,class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(itemIndex))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{key:fieldIndex,class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{key:fieldIndex,class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{key:fieldIndex,class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":itemIndex,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{key:fieldIndex,class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:itemIndex,rowField:field.sortField})],2):_vm._e()]:[_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.renderNormalField(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){_vm.onCellRightClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[_c('transition',{key:itemIndex,attrs:{"name":_vm.detailRowTransition}},[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":itemIndex}})],1)]):_vm._e()])]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{key:i,staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?_c('td',{key:fieldIndex},[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])])]):_c('table',{class:['vuetable', _vm.css.tableClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{key:fieldIndex,class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{key:fieldIndex,class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{key:fieldIndex,class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{key:fieldIndex,class:['vuetable-th-sequence', field.titleClass || '', _vm.sortClass(field)],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass || '', _vm.sortClass(field)],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass, _vm.sortClass(field),  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]})],2)]),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,itemIndex){return [_c('tr',{key:itemIndex,class:_vm.onRowClass(item, itemIndex),attrs:{"item-index":itemIndex,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)},"click":function($event){_vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{key:fieldIndex,class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(itemIndex))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{key:fieldIndex,class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{key:fieldIndex,class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{key:fieldIndex,class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":itemIndex,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{key:fieldIndex,class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:itemIndex,rowField:field.sortField})],2):_vm._e()]:[(_vm.hasCallback(field))?_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.callCallback(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){_vm.onCellRightClicked(item, field, $event)}}}):_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.getObjectValue(item, field.name, ''))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){_vm.onCellRightClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[_c('transition',{key:itemIndex,attrs:{"name":_vm.detailRowTransition}},[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":itemIndex}})],1)]):_vm._e()])]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{key:i,staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?_c('td',{key:fieldIndex},[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wpql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wzot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__ = __webpack_require__("N6Uh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e52161f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__ = __webpack_require__("cDZW");
function injectStyle (ssrContext) {
  __webpack_require__("WScA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e52161f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e52161f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X4hv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"beforeEnter":_vm.beforeEnter,"afterEnter":_vm.afterEnter,"beforeLeave":_vm.beforeLeave,"afterLeave":_vm.afterLeave}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XFBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification-dropdown',

  props: {
    options: {
      type: Array,
      default: function _default() {
        return [{
          name: 'sentMessage',
          details: { name: 'Vasily S' }
        }, {
          name: 'uploadedZip',
          details: { name: 'Oleg M', type: 'typography component' }
        }, {
          name: 'startedTopic',
          details: { name: 'Andrei H' }
        }];
      }
    }
  }
});

/***/ }),

/***/ "XK7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chat"},[_c('div',{directives:[{name:"sticky-scroll",rawName:"v-sticky-scroll",value:({animate: true, duration: 500}),expression:"{animate: true, duration: 500}"}],staticClass:"chat-body",style:({'height': _vm.height})},_vm._l((_vm.value),function(message){return _c('div',{staticClass:"chat-message",class:{'yours': message.yours, 'alien': !message.yours}},[_vm._v("\n       "+_vm._s(message.text)+"\n    ")])})),_vm._v(" "),_c('div',{staticClass:"chat-controls"},[_c('fieldset',[_c('div',{staticClass:"form-group form-group-w-btn"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputMessage),expression:"inputMessage"}],attrs:{"required":"","title":""},domProps:{"value":(_vm.inputMessage)},on:{"keypress":function($event){_vm.keyHandler($event)},"input":function($event){if($event.target.composing){ return; }_vm.inputMessage=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Your message")]),_c('i',{staticClass:"bar"})]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.sendMessage()}}},[_vm._v("Send")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XNYc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XdeI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xn4C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y+KL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__ = __webpack_require__("r/aY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d3575e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__ = __webpack_require__("uOC7");
function injectStyle (ssrContext) {
  __webpack_require__("nncG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d3575e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YHML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__ = __webpack_require__("2u3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c842fd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__ = __webpack_require__("8vMG");
function injectStyle (ssrContext) {
  __webpack_require__("kyy1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c842fd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c842fd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YMqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__ = __webpack_require__("U2Zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("Y+KL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-simple-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["a" /* default */]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__["a" /* default */]
  },
  props: {
    label: String,
    options: Array,
    value: {
      type: String,
      default: '',
      required: true
    },
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'simple-select'
    }
  },
  data: function data() {
    return {
      validated: false,
      displayValue: this.value
    };
  },

  watch: {
    value: {
      handler: function handler(value) {
        this.displayValue = value || '';
      },

      immediate: true
    }
  },
  computed: {
    filteredList: function filteredList() {
      var _this = this;

      return this.options.filter(function (item) {
        return item.search(_this.displayValue) === 0;
      });
    }
  },
  methods: {
    showDropdown: function showDropdown() {
      this.displayValue = '';
    },
    isOptionSelected: function isOptionSelected(option) {
      return this.displayValue === option;
    },
    selectOption: function selectOption(option) {
      this.displayValue = option;
      this.$emit('input', option);
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.value;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.value;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "YPsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-switch',
  props: {
    value: Boolean
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },

  methods: {
    setValue: function setValue(newVal) {
      this.$emit('input', newVal);
    }
  }
});

/***/ }),

/***/ "YUQB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YUx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("zkRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6041f29e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("gnEC");
function injectStyle (ssrContext) {
  __webpack_require__("NruP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6041f29e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6041f29e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_AppLayout__ = __webpack_require__("pb7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_AuthLayout__ = __webpack_require__("Eb6U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lazyLoading__ = __webpack_require__("77C1");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var demoRoutes = [];
if (false) {
  var VueComponentTree = require('vue-component-tree').default;

  demoRoutes.push(VueComponentTree(require.context('./..', true, /.demo.vue$/), '/demo'));
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  saveScrollPosition: true,
  routes: [].concat(demoRoutes, [{
    path: '*',

    redirect: { name: 'dashboard' }
  }, {
    name: 'separate-auth',
    path: '/auth',
    component: __WEBPACK_IMPORTED_MODULE_3__components_auth_AuthLayout__["default"],
    children: [{
      name: 'auth-login',
      path: '/auth/login',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('auth/login/Login'),
      default: true
    }, {
      name: 'auth-signup',
      path: '/auth/signup',
      redirect: { name: 'auth-login' },
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('auth/signup/Signup')
    }]
  }, {
    name: 'Admin',
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_2__components_admin_AppLayout__["default"],
    meta: { requiresAuth: true },
    children: [{
      name: 'dashboard',
      path: '/admin/dashboard',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('dashboard/Dashboard'),
      default: true
    }, {
      name: 'settings',
      path: '/admin/settings',
      meta: { title: 'Settings' }
    }, {
      name: 'settings-general',
      path: '/admin/settings/general',
      meta: { title: 'General' },
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('forms/medium-editor/MediumEditor')
    }, {
      name: 'settings-projects',
      path: '/admin/settings/projects',
      meta: { title: 'Projects' },
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('forms/form-wizard/FormWizard')
    }, {
      name: 'settings-users',
      path: '/admin/settings/users',
      meta: { title: 'Users' },
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('forms/medium-editor/MediumEditor')
    }, {
      name: 'stsc-survey',
      path: '/admin/stsc-survey'
    }, {
      name: 'survey-campaigns',
      path: '/admin/stsc-survey/campaigns',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('survey/campaigns/Campaigns')
    }, {
      name: 'survey-questions',
      path: '/admin/stsc-survey/questions',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('survey/questions/Questions')
    }, {
      name: 'survey-feedbacks',
      path: '/admin/stsc-survey/feedbacks',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('survey/feedbacks/Feedbacks')
    }, {
      name: 'statistics',
      path: '/admin/statistics'
    }, {
      name: 'charts',
      path: '/admin/statistics/charts',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('statistics/charts/Charts')
    }, {
      name: 'progress-bars',
      path: '/admin/statistics/progress-bars',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('statistics/progress-bars/ProgressBars')
    }, {
      name: 'forms',
      path: '/admin/forms'
    }, {
      name: 'form-elements',
      path: '/admin/forms/form-elements',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('forms/form-elements/FormElements')
    }, {
      name: 'form-wizard',
      path: '/admin/forms/form-wizard',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('forms/form-wizard/FormWizard')
    }, {
      name: 'medium-editor',
      path: '/admin/forms/medium-editor',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('forms/medium-editor/MediumEditor')
    }, {
      name: 'tables',
      path: '/admin/tables',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('tables/Table')
    }, {
      name: 'ui-elements',
      path: '/admin/ui'
    }, {
      name: 'typography',
      path: '/admin/ui/typography',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/typography/Typography')
    }, {
      name: 'buttons',
      path: '/admin/ui/buttons',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/buttons/Buttons')
    }, {
      name: 'notifications',
      path: '/admin/ui/notifications',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/notifications/Notifications')
    }, {
      path: '/admin/ui/icons',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/icons/Icons'),
      children: [{
        name: 'icons',
        path: '',
        component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/icons/SetsList')
      }, {
        path: ':name',
        component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/icons/Set'),
        props: true
      }]
    }, {
      name: 'spinners',
      path: '/admin/ui/spinners',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/spinners/Spinners')
    }, {
      name: 'grid',
      path: '/admin/ui/grid',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/grid/Grid')
    }, {
      name: 'modals',
      path: '/admin/ui/modals',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/modals/Modals')
    }, {
      name: 'tree-view',
      path: '/admin/ui/tree-view',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('ui/tree-view/TreeView')
    }, {
      name: 'extra',
      path: '/admin/extra',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('extra/Extra')
    }, {
      name: 'auth',
      path: '/admin/auth'
    }, {
      name: 'login',
      path: '/admin/auth/login',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('auth/login/Login')
    }, {
      name: 'signup',
      path: '/admin/auth/signup',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('auth/signup/Signup')
    }, {
      name: 'maps',
      path: '/admin/maps'
    }, {
      name: 'google-maps',
      path: '/admin/maps/google-maps',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('maps/google-maps/GoogleMapsPage')
    }, {
      name: 'yandex-maps',
      path: '/admin/maps/yandex-maps',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('maps/yandex-maps/YandexMapsPage')
    }, {
      name: 'leaflet-maps',
      path: '/admin/maps/leaflet-maps',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('maps/leaflet-maps/LeafletMapsPage')
    }, {
      name: 'bubble-maps',
      path: '/admin/maps/bubble-maps',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('maps/bubble-maps/BubbleMapsPage')
    }, {
      name: 'line-maps',
      path: '/admin/maps/line-maps',
      component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])('maps/line-maps/LineMapsPage')
    }]
  }])
}));

/***/ }),

/***/ "YeH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("l92n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_02d5b442_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("ArcP");
function injectStyle (ssrContext) {
  __webpack_require__("KPAF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02d5b442"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_02d5b442_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z5WX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-widget',

  props: ['headerText']
});

/***/ }),

/***/ "Z6hS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-node',
  props: {
    selected: {
      type: Boolean,
      default: false
    }

  }
});

/***/ }),

/***/ "Z9Vt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSidebar_vue__ = __webpack_require__("Fsqh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bddb911_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSidebar_vue__ = __webpack_require__("u9O0");
function injectStyle (ssrContext) {
  __webpack_require__("OzOB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bddb911_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZHXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-radio-button form-check radio abc-radio",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checkState},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s(_vm._f("translate")('forms.controls.radio')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZhTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-medium-editor"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZoX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'pixel-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                      ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                      0 ' + this.pixelSize * -1.5 + 'px 0 0\n                    '
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n      50% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n\n      75% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n      100% {\n        transform: rotate(360deg);\n      }';
    }
  }
});

/***/ }),

/***/ "aHv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__ = __webpack_require__("OX+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a068e0b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__ = __webpack_require__("AlLt");
function injectStyle (ssrContext) {
  __webpack_require__("uEn9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a068e0b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a068e0b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aaHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scaling-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b7Cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuestic-layout',[_c('app-navbar',{attrs:{"isOpen":_vm.opened},on:{"toggle-menu":_vm.toggleSidebar}}),_vm._v(" "),_c('app-sidebar',{attrs:{"isOpen":_vm.opened}}),_vm._v(" "),_c('main',{staticClass:"content",attrs:{"slot":"content","id":"content","role":"main"},slot:"content"},[_c('vuestic-breadcrumbs'),_vm._v(" "),_c('vuestic-pre-loader-stsc',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],ref:"preLoader",staticClass:"pre-loader-stsc"}),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v("©2018. Made by "),_c('a',{attrs:{"href":"https://smashtheshuttlecock.info","target":"_blank"}},[_vm._v("Smash The Shuttlecock ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b9Nl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bFyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-social-news"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center text-w-btn"},[_c('span',{staticClass:"text"},[_vm._v("That what users have posted about your business.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('button',{staticClass:"btn btn-micro btn-primary"},[_vm._v("VIEW")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-around photos"},_vm._l((_vm.news),function(pieceOfNews){return _c('div',{staticClass:"photo",style:(("background: url(" + (pieceOfNews.photoURL) + ")"))})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bGbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'spring-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        0% {\n          border-width: ' + this.size / 7 + 'px;\n        }\n        25% {\n          border-width: ' + this.size / 23.33 + 'px;\n        }\n        50% {\n          transform: rotate(115deg);\n          border-width: ' + this.size / 7 + 'px;\n        }\n        75% {\n          border-width: ' + this.size / 23.33 + 'px;\n         }\n        100% {\n         border-width: ' + this.size / 7 + 'px;\n        }';
    }
  }
});

/***/ }),

/***/ "byLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fingerprint-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"spinner-ring",style:(rs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bzB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-checkbox form-check abc-checkbox",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"abc-label-text"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cDZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flower-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"dots-container",style:(_vm.dotsContainerStyle)},[_c('div',{staticClass:"bigger-dot",style:(_vm.biggerDotStyle)},[_c('div',{staticClass:"smaller-dot",style:(_vm.smallerDotStyle)})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cdM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__ = __webpack_require__("66yB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d1869af_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__ = __webpack_require__("jIiw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d1869af_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "d2lb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-checkmark step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dPe/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


var palette = __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.palette;

/* harmony default export */ __webpack_exports__["a"] = ({
  legend: {
    position: 'bottom',
    labels: {
      fontColor: palette.fontColor,
      fontFamily: 'sans-serif',
      fontSize: 14,
      padding: 20,
      usePointStyle: true
    }
  },
  tooltips: {
    bodyFontSize: 14,
    bodyFontFamily: 'sans-serif'
  },
  responsive: true,
  maintainAspectRatio: false
});

/***/ }),

/***/ "dq31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__ = __webpack_require__("kl3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7537e9c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__ = __webpack_require__("WmOq");
function injectStyle (ssrContext) {
  __webpack_require__("IebZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7537e9c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7537e9c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eBYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__ = __webpack_require__("laTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e812593e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__ = __webpack_require__("T/73");
function injectStyle (ssrContext) {
  __webpack_require__("tX91")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e812593e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e812593e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eGfA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_tooltip__ = __webpack_require__("VN6J");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tooltip',

  directives: { tooltip: __WEBPACK_IMPORTED_MODULE_1_v_tooltip__["b" /* VTooltip */] },

  computed: {
    tooltipOptions: function tooltipOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultOptions, this.options);
    }
  },

  props: {
    options: {
      type: Object,
      default: {}
    }
  },

  data: function data() {
    return {
      defaultOptions: {
        classes: 'vuestic-tooltip'
      }
    };
  }
});

/***/ }),

/***/ "eOY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileDropdown_vue__ = __webpack_require__("/gWn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086f243c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileDropdown_vue__ = __webpack_require__("Eo30");
function injectStyle (ssrContext) {
  __webpack_require__("wSPK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086f243c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eOeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_vue__ = __webpack_require__("BcT4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e9f41c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_vue__ = __webpack_require__("9g8l");
function injectStyle (ssrContext) {
  __webpack_require__("tcd0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e9f41c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eWkE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ehv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["HorizontalBar"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp],
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.chartData, options);
  }
}));

/***/ }),

/***/ "epoO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "evu/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__ = __webpack_require__("10yw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aec6d4c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__ = __webpack_require__("0O39");
function injectStyle (ssrContext) {
  __webpack_require__("XdeI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aec6d4c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aec6d4c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f2UZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'size', 'isActive'],
  mounted: function mounted() {
    var _this = this;

    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (_this.animatedValue === 100) {
        current = progressColor;
        progressBar.style.backgroundColor = current();
        return;
      }
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "f8CP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'CONFIRM'
    },
    cancelText: {
      type: String,
      default: 'CANCEL'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-secondary'
    },
    closeIconShown: {
      type: Boolean,
      default: true
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === 'Escape') {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit('ok');
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener('keyup', this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "fB5I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");



var toastOptions = {
  theme: 'bubble',
  position: 'bottom-center',

  iconPack: 'fontawesome',
  duration: 2500
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_toasted___default.a, toastOptions);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showToast: function showToast(msg, options) {
      this.$toasted.show(msg, options);
    }
  }
});

/***/ }),

/***/ "fJoC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function generateRandomId() {
  return Math.floor(Math.random() * Math.pow(10, 10));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-checkbox',
  props: {
    label: String,
    id: {
      type: String,
      default: function _default() {
        return 'label-' + generateRandomId();
      }
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    brandColor: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  mounted: function mounted() {
    this.$emit('change', this.checked);
  },

  methods: {
    onChange: function onChange(event) {
      this.$emit('change', event.target.checked);
    }
  },
  computed: {
    additionalClasses: function additionalClasses() {
      return [this.isCircle ? 'abc-checkbox-circle' : false, 'abc-checkbox-' + this.brandColor];
    }
  }
});

/***/ }),

/***/ "fLFy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fPvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSlider_vue__ = __webpack_require__("j1c/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a949877_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSlider_vue__ = __webpack_require__("vUcU");
function injectStyle (ssrContext) {
  __webpack_require__("eWkE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a949877_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fjgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'size', 'isActive'],
  mounted: function mounted() {
    var _this = this;

    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (_this.animatedValue === 100) {
        current = progressColor;
        progressBar.style.backgroundColor = current();
        return;
      }
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "frcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown:focus",arg:"focus"}],staticClass:"form-group with-icon-right dropdown select-form-group multiselect-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle"},[_c('input',{class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","required":""},domProps:{"value":_vm.displayValue}}),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-arrow-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.toggleSelection(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))]),_vm._v(" "),_c('i',{staticClass:"fa fa-check selected-icon"})])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g5S/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle progress-bar",style:('background-image: ' + _vm.backgroundImage)},[_c('div',{staticClass:"overlay",style:('background-color: ' + _vm.backgroundColor + '; color: ' + _vm.color)},[_c('span',[_vm._v(_vm._s(_vm.animatedValue+'%'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gAE+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_StickyScroll__ = __webpack_require__("qLPH");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chat',

  directives: { StickyScroll: __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_StickyScroll__["a" /* default */] },

  props: {
    value: {
      type: Array,
      default: []
    },
    height: {
      default: '20rem'
    }
  },

  data: function data() {
    return {
      inputMessage: ''
    };
  },


  methods: {
    keyHandler: function keyHandler(event) {
      if (event.keyCode === 13) {
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage() {
      if (this.inputMessage) {
        this.$emit('input', this.value.concat({
          text: this.inputMessage,
          yours: true
        }));
        this.inputMessage = '';
      }
    }
  },

  mounted: function mounted() {
    this.$emit('input', this.value);
  }
});

/***/ }),

/***/ "gSMt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ghGU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gnEC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"looping-rhombuses-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{staticClass:"rhombus",style:(rs),attrs:{"ikey":index}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h+W8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "h+XH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"col nav-item dropdown navbar-dropdown"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"dropdown-menu-content"},[_vm._l((_vm.options),function(option,id){return _c('a',{key:id,staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.$t(("notifications." + (option.name)), { name: option.details.name, type: option.details.type })))])])}),_vm._v(" "),_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm._f("translate")('notifications.all')))])])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"i-nav-notification"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hWKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"language-dropdown dropdown"},[_c('a',{staticClass:"language-dropdown-button dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"flag-icon flag-icon-large",class:_vm.flagIconClass(_vm.currentLanguage())})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.options),function(option,id){return _c('a',{key:id,staticClass:"dropdown-item",class:{ active: option.code === _vm.currentLanguage() },on:{"click":function($event){_vm.setLanguage(option.code)}}},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.flagIconClass(option.code)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item-text ellipsis"},[_vm._v("\n        "+_vm._s(_vm._f("translate")(("language." + (option.name))))+"\n      ")])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hvgk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iLy1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-profile-card',
  props: ['photoSource', 'name', 'location', 'social']
});

/***/ }),

/***/ "iRgv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical"},[_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('height: ' + _vm.value + '%')})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iYEl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ihFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.hidden)?_c('div',{staticClass:"vuestic-alert alert",class:_vm.alertClass},[_vm._t("default"),_vm._v(" "),(_vm.withCloseBtn)?_c('i',{staticClass:"fa fa-close alert-close",on:{"click":function($event){_vm.hide()}}}):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ihPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPopover_vue__ = __webpack_require__("4J/c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20282df1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPopover_vue__ = __webpack_require__("yiDD");
function injectStyle (ssrContext) {
  __webpack_require__("5AY4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20282df1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPopover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20282df1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPopover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j1c/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store__ = __webpack_require__("IcnI");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-slider',

  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },

  props: {
    value: {
      type: Number,
      required: true
    },

    options: {
      type: Object
    }
  },

  data: function data() {
    return {
      defaultOptions: {
        dotSize: 16,
        height: 2,
        realTime: true,
        sliderStyle: {
          'background-color': __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette.primary,
          'box-shadow': 'none'
        },
        processStyle: {
          'background-color': __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette.primary
        },
        tooltipStyle: {
          'background-color': __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette.primary,
          'border-color': __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette.primary
        }
      }
    };
  },

  computed: {
    sliderOptions: function sliderOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultOptions, this.options);
    }
  },

  methods: {
    change: function change(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),

/***/ "jIiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuestic-sidebar',{attrs:{"hidden":this.isOpen,"toggleWithoutAnimation":_vm.toggleWithoutAnimation}},[_c('template',{attrs:{"slot":"menu"},slot:"menu"},[_c('sidebar-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon vuestic-icon vuestic-icon-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menu.dashboard')))])])]),_vm._v(" "),_c('sidebar-link-group',[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon vuestic-icon vuestic-icon-files"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menu.survey')))])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":{ name: 'survey-campaigns' }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon fa fa-calendar-check-o"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.$t('menu.surveyCampaigns'))))])])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":{ name: 'survey-questions' }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon fa fa-question-circle-o"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.$t('menu.surveyQuestions'))))])])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":{ name: 'survey-feedbacks' }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon fa fa-comment-o"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.$t('menu.surveyFeedbacks'))))])])])],1),_vm._v(" "),_c('sidebar-link-group',[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon vuestic-icon vuestic-icon-settings"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menu.settings')))])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":{ name: 'settings-general' }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon fa fa-tachometer"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.$t('menu.settingsGeneral'))))])])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":{ name: 'settings-projects' }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon fa fa-folder-o"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.$t('menu.settingsProjects'))))])])]),_vm._v(" "),_c('sidebar-link',{attrs:{"to":{ name: 'settings-users' }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"sidebar-menu-item-icon fa fa-user-o"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm._f("translate")(_vm.$t('menu.settingsUsers'))))])])])],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jpRP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jrTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__ = __webpack_require__("fjgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80dc47ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__ = __webpack_require__("iRgv");
function injectStyle (ssrContext) {
  __webpack_require__("3ZnJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80dc47ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kH5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__ = __webpack_require__("NpL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f8540cd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__ = __webpack_require__("CdEK");
function injectStyle (ssrContext) {
  __webpack_require__("pTr/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8540cd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f8540cd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kfHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tabs',

  props: ['names'],

  computed: {
    underscoreClass: function underscoreClass() {
      return 'underscore-' + this.names.length + '-' + this.names.indexOf(this.currentActive);
    }
  },

  mounted: function mounted() {
    if (this.isNotNullorUndefined(this.routeQuery().tab)) {
      this.setActive(this.routeQuery().tab);
    }
  },


  methods: {
    setActive: function setActive(name) {
      this.currentActive = name;
      this.$router.push('?tab=' + name);
    }
  },
  data: function data() {
    return {
      currentActive: this.names[0]
    };
  }
});

/***/ }),

/***/ "kl3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: null
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: null
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: [Object, Function],
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: 10
    },
    initialPage: {
      type: Number,
      default: 1
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No Data Available';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    version: function version() {
      return VERSION;
    },
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {
        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {
      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      if (data === null || typeof data === 'undefined') return;

      this.fireEvent('loading');

      if (Array.isArray(data)) {
        this.tableData = data;
        this.fireEvent('loaded');
        return;
      }

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        var iconTag = this.showSortIcons ? this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"') : '';
        return title + ' ' + iconTag;
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAppendParams(this.getAllQueryParams());

      return this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_1_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};

      if (typeof this.queryParams === 'function') {
        params = this.queryParams(this.sortOrder, this.currentPage, this.perPage);
        return (typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(params)) !== 'object' ? {} : params;
      }

      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] === 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }
      return result;
    },
    getAppendParams: function getAppendParams(params) {
      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      if (this.apiMode || this.dataManager) {
        this.loadData();
      }
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortClass: function sortClass(field) {
      var cls = '';
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingClass : this.css.descendingClass;
      }

      return cls;
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        return this.setData(this.data);
      }

      this.normalizeSortOrder();

      return this.setData(this.dataManager ? this.dataManager(this.sortOrder, this.makePagination()) : this.data);
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    onCellRightClicked: function onCellRightClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-rightclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      return this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      return this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    },
    'data': function data(newVal, oldVal) {
      this.setData(newVal);
    },
    'tableHeight': function tableHeight(newVal, oldVal) {
      this.fixHeader();
    }
  }
});

/***/ }),

/***/ "kyy1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l92n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "laTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
});

/***/ }),

/***/ "lhlx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__ = __webpack_require__("bGbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c2b7a9a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__ = __webpack_require__("8bIR");
function injectStyle (ssrContext) {
  __webpack_require__("iYEl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c2b7a9a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c2b7a9a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_args":[[{"raw":"vue-chartjs@^2.8.1","scope":null,"escapedName":"vue-chartjs","name":"vue-chartjs","rawSpec":"^2.8.1","spec":">=2.8.1 <3.0.0","type":"range"},"S:\\WoRkSpAcE\\Project\\STSC\\Project\\Web\\dashboard"]],"_from":"vue-chartjs@>=2.8.1 <3.0.0","_id":"vue-chartjs@2.8.7","_inCache":true,"_location":"/vue-chartjs","_nodeVersion":"8.5.0","_npmOperationalInternal":{"host":"s3://npm-registry-packages","tmp":"tmp/vue-chartjs-2.8.7.tgz_1505561838079_0.5062592723406851"},"_npmUser":{"name":"apertureless","email":"juszczak.j@googlemail.com"},"_npmVersion":"5.4.2","_phantomChildren":{},"_requested":{"raw":"vue-chartjs@^2.8.1","scope":null,"escapedName":"vue-chartjs","name":"vue-chartjs","rawSpec":"^2.8.1","spec":">=2.8.1 <3.0.0","type":"range"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_shasum":"bcd1cda1a1ef8ed80581638a02cf88182d437d09","_shrinkwrap":null,"_spec":"vue-chartjs@^2.8.1","_where":"S:\\WoRkSpAcE\\Project\\STSC\\Project\\Web\\dashboard","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"directories":{},"dist":{"integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","shasum":"bcd1cda1a1ef8ed80581638a02cf88182d437d09","tarball":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"gitHead":"58523d6155ce5c0c6371da4ad7e0afa976743d89","greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"apertureless","email":"juszczak.j@googlemail.com"}],"module":"es/index.js","name":"vue-chartjs","optionalDependencies":{},"peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"readme":"ERROR: No README data found!","repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ "lx53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],staticClass:"layout",class:_vm.classObject},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"content-wrap",attrs:{"id":"content-wrap"}},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"made-by-footer"},[_vm._t("footer")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lzfd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mKJi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUJ2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./admin/AppLayout.vue": [
		"pb7V"
	],
	"./admin/app-navbar/AppNavbar.vue": [
		"M8Jl"
	],
	"./admin/app-navbar/components/HeaderSelector.vue": [
		"Rubq"
	],
	"./admin/app-navbar/components/dropdowns/LanguageDropdown.vue": [
		"CqZu"
	],
	"./admin/app-navbar/components/dropdowns/MessageDropdown.vue": [
		"HouA"
	],
	"./admin/app-navbar/components/dropdowns/NotificationDropdown.vue": [
		"sWYs"
	],
	"./admin/app-navbar/components/dropdowns/ProfileDropdown.vue": [
		"eOY8"
	],
	"./admin/app-sidebar/AppSidebar.vue": [
		"cdM8"
	],
	"./admin/app-sidebar/components/SidebarLink.vue": [
		"SZ1I"
	],
	"./admin/app-sidebar/components/SidebarLinkGroup.vue": [
		"xrxJ"
	],
	"./auth/AuthLayout.vue": [
		"Eb6U"
	],
	"./auth/login/Login.vue": [
		"mEJK",
		58
	],
	"./auth/signup/Signup.vue": [
		"5rG8",
		57
	],
	"./dashboard/Dashboard.vue": [
		"UE3e",
		0
	],
	"./dashboard/DashboardBottomWidgets.vue": [
		"g2tC",
		56
	],
	"./dashboard/DashboardInfoWidgets.vue": [
		"8D9j",
		55
	],
	"./dashboard/data-visualisation-tab/DataVisualisation.vue": [
		"0404",
		13
	],
	"./dashboard/features-tab/FeaturesTab.vue": [
		"ilf6",
		54
	],
	"./dashboard/setup-profile-tab/SetupProfileTab.vue": [
		"hnAi",
		27
	],
	"./dashboard/users-and-members-tab/UsersMembersTab.vue": [
		"HLpY",
		53
	],
	"./extra/Extra.vue": [
		"i3SW",
		4
	],
	"./forms/form-elements/FormElements.vue": [
		"1d7L",
		26
	],
	"./forms/form-wizard/FormWizard.vue": [
		"BIYo",
		25
	],
	"./forms/medium-editor/MediumEditor.vue": [
		"KIGi",
		52
	],
	"./maps/bubble-maps/BubbleMap.vue": [
		"4B14",
		16
	],
	"./maps/bubble-maps/BubbleMapsPage.vue": [
		"Vn7A",
		9
	],
	"./maps/google-maps/GoogleMap.vue": [
		"B2vT",
		22
	],
	"./maps/google-maps/GoogleMapsPage.vue": [
		"mL/o",
		18
	],
	"./maps/leaflet-maps/LeafletMap.vue": [
		"psFn",
		21
	],
	"./maps/leaflet-maps/LeafletMapsPage.vue": [
		"+Tox",
		11
	],
	"./maps/line-maps/LineMap.vue": [
		"8NYS",
		15
	],
	"./maps/line-maps/LineMapsPage.vue": [
		"P0w/",
		8
	],
	"./maps/yandex-maps/YandexMapsPage.vue": [
		"RuII",
		51
	],
	"./statistics/charts/Charts.vue": [
		"dfb7",
		7
	],
	"./statistics/progress-bars/ProgressBars.vue": [
		"J1Wx",
		17
	],
	"./statistics/progress-bars/Widgets/ColorfulBars.vue": [
		"xFHm",
		64
	],
	"./statistics/progress-bars/Widgets/StandardBars.vue": [
		"Lgc7",
		63
	],
	"./survey/SurveyBottomWidgets.vue": [
		"VIC9",
		50
	],
	"./survey/campaigns/Campaigns.vue": [
		"D1WE",
		3
	],
	"./survey/campaigns/SurveyCampaignsInfoWidgets.vue": [
		"3PH/",
		49
	],
	"./survey/campaigns/survey-campaigns-add-tab/SurveyCampaignsAddTab.vue": [
		"rwrJ",
		48
	],
	"./survey/campaigns/survey-campaigns-data-visualisation-tab/SurveyCampaignsDataVisualisation.vue": [
		"IW0n",
		28
	],
	"./survey/campaigns/survey-campaigns-list-tab/ActionColumnCampaignsList.vue": [
		"v6Ca",
		47
	],
	"./survey/campaigns/survey-campaigns-list-tab/SurveyCampaignsListTab.vue": [
		"tR83",
		19
	],
	"./survey/campaigns/survey-campaigns-log-tab/SurveyCampaignsLogTab.vue": [
		"goJP",
		46
	],
	"./survey/feedbacks/Feedbacks.vue": [
		"7lKp",
		1
	],
	"./survey/feedbacks/SurveyFeedbacksInfoWidgets.vue": [
		"XyuK",
		45
	],
	"./survey/feedbacks/data-visualisation-tab/DataVisualisation.vue": [
		"3mxX",
		12
	],
	"./survey/feedbacks/features-tab/FeaturesTab.vue": [
		"XT3N",
		44
	],
	"./survey/feedbacks/setup-profile-tab/SetupProfileTab.vue": [
		"9k1D",
		24
	],
	"./survey/feedbacks/users-and-members-tab/UsersMembersTab.vue": [
		"9j+E",
		43
	],
	"./survey/questions/Questions.vue": [
		"4HUv",
		2
	],
	"./survey/questions/SurveyQuestionsInfoWidgets.vue": [
		"dE8X",
		42
	],
	"./survey/questions/questions-add-tab/QuestionsAddTab.vue": [
		"4XgE",
		23
	],
	"./survey/questions/questions-list-tab/ActionColumnQuestionsList.vue": [
		"ItM/",
		41
	],
	"./survey/questions/questions-list-tab/BadgeColumnQuestionsList.vue": [
		"479/",
		40
	],
	"./survey/questions/questions-list-tab/QuestionsListTab.vue": [
		"uc74",
		10
	],
	"./survey/questions/questions-log-tab/QuestionsLogTab.vue": [
		"8EG+",
		39
	],
	"./tables/BadgeColumn.vue": [
		"csLD",
		38
	],
	"./tables/Table.vue": [
		"7vQb",
		14
	],
	"./ui/buttons/Buttons.vue": [
		"906U",
		37
	],
	"./ui/grid/Grid.vue": [
		"B8IG",
		36
	],
	"./ui/icons/Icons.vue": [
		"qzeV",
		5
	],
	"./ui/icons/Set.vue": [
		"G7oI",
		35
	],
	"./ui/icons/SetsList.vue": [
		"uaIo",
		34
	],
	"./ui/modals/Modals.vue": [
		"g/Tc",
		33
	],
	"./ui/notifications/Notifications.vue": [
		"hiVg",
		20
	],
	"./ui/notifications/ToastPositionPicker.vue": [
		"9me2",
		32
	],
	"./ui/spinners/Spinners.vue": [
		"jNlQ",
		31
	],
	"./ui/tree-view/TreeView.vue": [
		"sN7A",
		6
	],
	"./ui/tree-view/TreeViewAdvancedPreview.vue": [
		"9Kgs",
		62
	],
	"./ui/tree-view/TreeViewBasicPreview.vue": [
		"HAQJ",
		61
	],
	"./ui/tree-view/TreeViewEditablePreview.vue": [
		"QtuA",
		30
	],
	"./ui/tree-view/TreeViewIconsPreview.vue": [
		"gFSd",
		60
	],
	"./ui/tree-view/TreeViewSelectablePreview.vue": [
		"3svY",
		59
	],
	"./ui/typography/Typography.vue": [
		"5VNW",
		29
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mUJ2";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "mUqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-widget',{staticClass:"no-padding no-v-padding"},[_c('div',{staticClass:"vuestic-breadcrumbs"},[_c('router-link',{staticClass:"crumb",attrs:{"to":'/'}},[_vm._v(_vm._s(_vm._f("translate")('breadcrumbs.home')))]),_vm._v(" "),_vm._l((_vm.breadcrumbs),function(item,index){return _c('router-link',{key:index,staticClass:"crumb",class:{ disabled: !item.path || item.meta.breadcrumbDisabled },attrs:{"to":{path: item.path}}},[_vm._v("\n          "+_vm._s(_vm._f("translate")(item.meta.title))+"\n        ")])})],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mWYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('en', __webpack_require__("UpdR"));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('es', __webpack_require__("WlTu"));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('vn', __webpack_require__("NgTC"));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set('en');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.fallback('en');

/***/ }),

/***/ "ml8A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "nErf":
/***/ (function(module, exports) {

module.exports = [{"x":0,"y":0},{"x":8,"y":12},{"x":16,"y":24},{"x":24,"y":36},{"x":32,"y":48},{"x":40,"y":60},{"x":48,"y":72},{"x":60,"y":84},{"x":72,"y":72},{"x":80,"y":60},{"x":88,"y":48},{"x":96,"y":36},{"x":104,"y":24},{"x":112,"y":12},{"x":120,"y":0},{"x":104,"y":0},{"x":88,"y":0},{"x":80,"y":12},{"x":72,"y":24},{"x":60,"y":36},{"x":48,"y":24},{"x":40,"y":10},{"x":32,"y":0},{"x":16,"y":0}]

/***/ }),

/***/ "nZ+C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "niZM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__ = __webpack_require__("/XqH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11313824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__ = __webpack_require__("yx39");
function injectStyle (ssrContext) {
  __webpack_require__("ztJv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11313824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nljM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('i',{staticClass:"ion ion-md-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-checkmark step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-line"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nncG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "noQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el) {
    var getWindowMatch = function getWindowMatch() {
      return window.matchMedia(__WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.config.windowMatchSizeLg).matches;
    };

    var prevMatchlg = getWindowMatch();

    el.addEventListener('transitionend', function () {
      __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('isToggleWithoutAnimation', false);
    });

    window.addEventListener('resize', function () {
      if (getWindowMatch() && !prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('toggleSidebar', true);
      } else if (!getWindowMatch() && prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('isToggleWithoutAnimation', true);
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('toggleSidebar', false);
      }
      prevMatchlg = getWindowMatch();
    });
  }
});

/***/ }),

/***/ "nolp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__("pyJd");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-pre-loader-stsc',

  components: {
    'fingerprint-spinner': __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["FingerprintSpinner"]
  }
});

/***/ }),

/***/ "oKE4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-social-news',
  props: ['news', 'url']
});

/***/ }),

/***/ "oLtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:{'no-header': !_vm.headerText}},[(_vm.headerText)?_c('div',{staticClass:"widget-header"},[_vm._v(_vm._s(_vm.headerText))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oRuh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "obAf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datatable_components_FilterBar_vue__ = __webpack_require__("s0HW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datatable_components_ItemsPerPage_vue__ = __webpack_require__("evu/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__ = __webpack_require__("7qYU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuestic_datatable_data_data_table_styles__ = __webpack_require__("KMiR");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-data-table',
  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_5__datatable_components_FilterBar_vue__["a" /* default */],
    Vuetable: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_6__datatable_components_ItemsPerPage_vue__["a" /* default */]
  },
  props: {
    apiUrl: {
      type: String
    },
    httpFetch: {
      type: Function,
      default: null
    },
    httpOptions: {
      type: Object,
      default: function _default() {}
    },
    filterQuery: {
      type: String,
      default: 'filter'
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage;
      }
    },
    perPageSelectorShown: {
      type: Boolean,
      default: true
    },
    filterInputShown: {
      type: Boolean,
      default: true
    },
    filterInputLabel: {
      type: String,
      default: 'Search'
    },
    itemsPerPageLabel: {
      type: String,
      default: 'per page'
    },
    defaultPerPage: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage[0].value
    },
    onEachSide: {
      type: Number,
      default: 2
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Object,
      default: function _default() {
        return {
          data: []
        };
      }
    },
    dataModeFilterableFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: ''
    },
    queryParams: {
      type: Object
    }
  },
  data: function data() {
    return {
      perPage: 0,
      colorClasses: {},
      filterText: '',
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_9__vuestic_datatable_data_data_table_styles__["a" /* default */]
    };
  },

  watch: {
    tableData: {
      handler: function handler(val) {
        this.$refs.vuetable.refresh();
      },

      deep: true
    }
  },
  computed: {
    controlsAlignmentClass: function controlsAlignmentClass() {
      return {
        'justify-content-md-between': this.filterInputShown,
        'justify-content-md-end': !this.filterInputShown
      };
    },
    moreParams: function moreParams() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, this.filterQuery, this.filterText);
    },
    dataModeFilterableFieldsComputed: function dataModeFilterableFieldsComputed() {
      var dataItem = this.tableData.data[0] || {};
      var filterableFields = this.dataModeFilterableFields;

      if (!filterableFields.length) {
        var itemFields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataItem);
        itemFields.forEach(function (field) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(dataItem[field]) !== 'object') {
            filterableFields.push(field);
          }
        });
      }

      return filterableFields;
    },
    filteredTableData: function filteredTableData() {
      var _this = this;

      var txt = new RegExp(this.filterText, 'i');

      var filteredData = this.tableData.data.slice();

      filteredData = this.tableData.data.filter(function (item) {
        return _this.dataModeFilterableFieldsComputed.some(function (field) {
          var val = item[field] + '';
          return val.search(txt) >= 0;
        });
      });

      return {
        data: filteredData
      };
    },
    defaultPerPageComputed: function defaultPerPageComputed() {
      var defaultPerPage = __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage[0].value;

      if (this.$options.propsData.defaultPerPage) {
        defaultPerPage = this.$options.propsData.defaultPerPage;
      } else if (this.$options.propsData.itemsPerPage) {
        defaultPerPage = this.$options.propsData.itemsPerPage[0].value;
      }

      return defaultPerPage;
    },
    paginationPathComputed: function paginationPathComputed() {
      return this.apiMode ? this.paginationPath : 'pagination';
    }
  },

  created: function created() {
    this.perPage = this.defaultPerPageComputed;
  },
  mounted: function mounted() {
    this.$emit('initialized', this.$refs.vuetable);
  },


  methods: {
    onFilterSet: function onFilterSet(filterText) {
      var _this2 = this;

      this.filterText = filterText;
      __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this3 = this;

      this.perPage = itemsPerPageValue;
      __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.filteredTableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === 'desc') {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "ol33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"vuestic-navbar navbar navbar-toggleable-md"},[_c('div',{staticClass:"vuestic-navbar__logo"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/dashboard"}},[_vm._t("logo")],2)],1),_vm._v(" "),_c('div',{staticClass:"row vuestic-navbar__content"},[_c('div',{staticClass:"header-elem-wrapper"},[_vm._t("selector")],2),_vm._v(" "),_c('div',{staticClass:"header-elem-wrapper navbar-text offset-md-1 col-md-7"},[_vm._t("center")],2),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pTr/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pb7V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__ = __webpack_require__("2iiT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_363a0046_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__ = __webpack_require__("b7Cb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_363a0046_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pjCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-root',
  methods: {
    collapse: function collapse() {
      var _this = this;

      this.$nextTick(function () {
        _this.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.collapse();
          }
        });
      });
    },
    expand: function expand() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.expand();
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "qB2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-feed',
  props: ['initialPosts'],
  methods: {
    removePost: function removePost(target) {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var post = _step.value;

          if (post !== target) {
            result.push(post);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.posts = result;
    }
  },
  data: function data() {
    return {
      posts: this.initialPosts
    };
  }
});

/***/ }),

/***/ "qHzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("h+W8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9804fed2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("3Uqw");
function injectStyle (ssrContext) {
  __webpack_require__("rgQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9804fed2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9804fed2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qLPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var duration = binding.value.duration || 500;
    var isAnimated = binding.value.animate;

    var observer = new MutationObserver(scrollToBottom);
    var config = { childList: true };
    observer.observe(el, config);

    function animateScroll(duration) {
      var start = el.scrollTop;
      var end = el.scrollHeight;
      var change = end - start;
      var increment = 20;

      function easeInOut(currentTime, start, change, duration) {
        currentTime /= duration / 2;
        if (currentTime < 1) {
          return change / 2 * currentTime * currentTime + start;
        }
        currentTime -= 1;
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
      }

      function animate(elapsedTime) {
        elapsedTime += increment;
        var position = easeInOut(elapsedTime, start, change, duration);
        el.scrollTop = position;

        if (elapsedTime < duration) {
          setTimeout(function () {
            animate(elapsedTime);
          }, increment);
        }
      }

      animate(0);
    }

    function scrollToBottom() {
      if (isAnimated) {
        animateScroll(duration);
      } else {
        el.scrollTop = el.scrollHeight;
      }
    }
  }
});

/***/ }),

/***/ "r/aY":
/***/ (function(module, exports, __webpack_require__) {



var browser = __webpack_require__("bJUU");
var erd = __webpack_require__("uk2G")();

var vm = {
  name: 'vuestic-scrollbar',
  props: {
    speed: {
      default: 20
    }
  },
  methods: {
    calcSize: function calcSize() {
      this.isDown = this.isUp = false;
      this.maxHeight = parseFloat(this.wrapper.offsetHeight, 10);
      this.contentHeight = parseFloat(this.content.offsetHeight, 10);
      this.trackHeight = parseFloat(this.track.offsetHeight, 10);

      if (this.maxHeight / this.contentHeight * this.trackHeight < 10) {
        this.thumb.style.height = 10 + 'px';
      } else {
        this.thumb.style.height = this.maxHeight / this.contentHeight * this.trackHeight + 'px';
      }

      if (this.maxHeight / this.contentHeight < 1) {
        this.thumb.classList.add('active');
      } else {
        this.thumb.classList.remove('active');
      }
    },
    calcThumb: function calcThumb() {
      var currentMT = this.content.style.marginTop === '' ? 0 : parseInt(this.content.style.marginTop, 10);
      this.thumb.style.top = -currentMT / this.contentHeight * this.trackHeight + 'px';
    },
    onContentResize: function onContentResize() {
      var _this = this;

      var prevHeight = this.contentHeight;
      this.calcSize();
      this.calcThumb();

      this.content.style.transition = 'margin-top .3s linear';
      this.thumb.style.transition = 'top .3s linear';
      var handler = function handler(e) {
        if (e.propertyName === 'margin-top') {
          _this.content.style.transition = '';
          _this.calcSize();
          _this.calcThumb();
          _this.content.removeEventListener('transitionend', handler);
          _this.thumb.style.transition = '';
        }
      };
      this.content.addEventListener('transitionend', handler);

      this.setVertical(this.contentHeight - prevHeight);
    },
    startDrag: function startDrag(e) {
      this.isDragging = true;
      this.prevTouch = e.touches[0];
    },
    onDrag: function onDrag(e) {
      if (this.isDragging) {
        e.preventDefault();
        var touch = e.touches[0];
        var delta = this.prevTouch.clientY - touch.clientY;
        this.setVertical(delta);
        this.prevTouch = touch;
      }
    },
    stopDrag: function stopDrag(e) {
      this.isDragging = false;
    },
    scroll: function scroll(e) {
      var delta = e.deltaY * 0.01 * this.speed;
      if (browser.name === 'firefox') {
        delta *= 10;
      }
      this.setVertical(delta);
      e.preventDefault();
    },
    setVertical: function setVertical(delta) {
      if (this.isDown && delta > 0 || this.isUp && delta < 0 || this.contentHeight <= this.maxHeight) {
        return;
      }
      var currentMT = this.content.style.marginTop === '' ? 0 : parseFloat(this.content.style.marginTop, 10);
      var nextMT = 0;
      if (this.maxHeight - (currentMT - delta) > this.contentHeight && delta > 0) {
        nextMT = this.maxHeight - this.contentHeight;
        this.isDown = true;
      } else {
        this.isDown = false;
        if (currentMT - delta > 0) {
          this.isUp = true;
          nextMT = 0;
        } else {
          nextMT = currentMT - delta;
          this.isUp = false;
        }
      }

      this.content.style.marginTop = nextMT + 'px';
      this.calcThumb();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.track = this.$refs.track;
    this.thumb = this.$refs.thumb;
    this.content = this.$refs.scrollbarContent;
    this.wrapper = this.$refs.scrollbarWrapper;
    this.calcSize();
    this.calcThumb();
    erd.listenTo(this.content, function () {
      _this2.calcSize();
      _this2.calcThumb();
    });
  },
  beforeDestroy: function beforeDestroy() {
    erd.removeAllListeners(this.content);
  },
  data: function data() {
    return {
      wrapper: undefined,
      maxHeight: undefined,
      thumb: undefined,
      track: undefined,
      trackHeight: undefined,
      content: undefined,
      contentHeight: undefined,
      isDown: false,
      isUp: true,
      prevTouch: {},
      isDragging: false
    };
  }
};

module.exports = vm;

/***/ }),

/***/ "r8Mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "rSdb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rgQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rhXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chart"},[(_vm.type === 'pie')?_c('pie-chart',{attrs:{"options":_vm.options,"chart-data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'donut')?_c('donut-chart',{attrs:{"options":_vm.options,"chart-data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'bubble')?_c('bubble-chart',{attrs:{"options":_vm.options,"chart-data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'line')?_c('line-chart',{attrs:{"options":_vm.options,"chart-data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'horizontal-bar')?_c('horizontal-bar-chart',{attrs:{"options":_vm.options,"chart-data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'vertical-bar')?_c('vertical-bar-chart',{attrs:{"options":_vm.options,"chart-data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "riaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"col nav-item dropdown navbar-dropdown"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"dropdown-menu-content"},[_vm._l((_vm.options),function(option,id){return _c('a',{key:id,staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.$t(("messages." + (option.name)), { name: option.details.name})))])])}),_vm._v(" "),_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm._f("translate")('messages.all')))])])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"i-nav-messages"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rvkD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breeding-rhombus-spinner",style:(_vm.spinnerStyle)},[_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{key:index,staticClass:"rhombus",class:("child-" + (index + 1)),style:(rs)})}),_vm._v(" "),_c('div',{staticClass:"rhombus big",style:(_vm.bigRhombusStyle)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s+US":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'startColor', 'backgroundColor', 'isActive'],
  computed: {
    backgroundImage: function backgroundImage() {
      var result = {};
      if (this.animatedValue < 50) {
        var nextDeg = 90 + 3.6 * this.animatedValue + 'deg';
        result = 'linear-gradient(90deg, ' + this.startColor + ' 50%, transparent 50%, transparent), linear-gradient(' + nextDeg + ', ' + this.color + ' 50%, ' + this.startColor + ' 50%, ' + this.startColor + ')';
      } else {
        var _nextDeg = -90 + 3.6 * (this.animatedValue - 50) + 'deg';
        result = 'linear-gradient(' + _nextDeg + ', ' + this.color + ' 50%, transparent 50%, transparent), linear-gradient(270deg, ' + this.color + ' 50%, ' + this.startColor + ' 50%, ' + this.startColor + ')';
      }
      return result;
    }
  }
});

/***/ }),

/***/ "s0HW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("Kss2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50cbc939_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("MyMC");
function injectStyle (ssrContext) {
  __webpack_require__("fLFy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50cbc939"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50cbc939_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sWYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationDropdown_vue__ = __webpack_require__("XFBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ebd7d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationDropdown_vue__ = __webpack_require__("h+XH");
function injectStyle (ssrContext) {
  __webpack_require__("C9Ox")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ebd7d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sxwz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circles-to-rhombuses-spinner",style:(_vm.spinnertStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tKDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tX91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tcEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "tcd0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tgcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__ = __webpack_require__("/VHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da3635e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__ = __webpack_require__("rhXu");
function injectStyle (ssrContext) {
  __webpack_require__("lzfd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da3635e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u+5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMediumEditor_vue__ = __webpack_require__("P+0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3159ef4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMediumEditor_vue__ = __webpack_require__("ZhTZ");
function injectStyle (ssrContext) {
  __webpack_require__("2XB0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMediumEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3159ef4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMediumEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u9O0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"vuestic-sidebar",class:_vm.classObject},[_c('vuestic-scrollbar',[_c('ul',{staticClass:"sidebar-menu"},[_vm._t("menu")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uEn9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uOC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vuesticScrollbar",staticClass:"vuestic-scrollbar"},[_c('div',{ref:"scrollbarWrapper",staticClass:"scrollbar-wrapper"},[_c('div',{ref:"scrollbarContent",staticClass:"scrollbar-content",on:{"wheel":_vm.scroll,"touchstart":_vm.startDrag,"touchmove":_vm.onDrag,"touchend":_vm.stopDrag,"transitionend":_vm.onContentResize}},[_vm._t("default")],2),_vm._v(" "),_c('div',{ref:"track",staticClass:"track"},[_c('div',{ref:"thumb",staticClass:"thumb"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uRDv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uxTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__ = __webpack_require__("f8CP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b066b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__ = __webpack_require__("3JM9");
function injectStyle (ssrContext) {
  __webpack_require__("b9Nl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b066b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vHzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_vue__ = __webpack_require__("pjCh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad695cda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_vue__ = __webpack_require__("0Gsu");
function injectStyle (ssrContext) {
  __webpack_require__("xqJG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad695cda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vUcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slider',_vm._b({staticClass:"vuestic-slider",attrs:{"value":_vm.value,"bg-style":_vm.sliderOptions.bgStyle,"slider-style":_vm.sliderOptions.sliderStyle},on:{"input":_vm.change}},'slider',_vm.sliderOptions,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vW50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("TqEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bff9ecb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("EjwN");
function injectStyle (ssrContext) {
  __webpack_require__("06SC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bff9ecb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bff9ecb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vd+D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vh2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticBreadcrumbs_vue__ = __webpack_require__("yBS9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13fc0ede_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticBreadcrumbs_vue__ = __webpack_require__("mUqK");
function injectStyle (ssrContext) {
  __webpack_require__("uRDv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13fc0ede"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticBreadcrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13fc0ede_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticBreadcrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vi3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "wSPK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x4Yd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component__ = __webpack_require__("QKlT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-date-picker',
  components: {
    VueFlatpickrComponent: __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component___default.a
  },
  props: {
    value: {
      required: true
    },
    config: {
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    valueProxy: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    fullConfig: function fullConfig() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultConfig, this.config);
    },
    defaultConfig: function defaultConfig() {
      return {
        nextArrow: '<span aria-hidden="true" class="ion ion-ios-arrow-forward"></span>',
        prevArrow: '<span aria-hidden="true" class="ion ion-ios-arrow-back"></span>'
      };
    }
  }
});

/***/ }),

/***/ "xEkJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'language-dropdown',

  props: {
    options: {
      type: Array,
      default: function _default() {
        return [{
          code: 'us',
          name: 'english'
        }, {
          code: 'vn',
          name: 'vietnamese'
        }, {
          code: 'es',
          name: 'spanish'
        }];
      }
    }
  },

  methods: {
    setLanguage: function setLanguage(locale) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set(locale);
    },
    currentLanguage: function currentLanguage() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.locale() === 'en' ? 'us' : __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.locale();
    },
    flagIconClass: function flagIconClass(code) {
      return 'flag-icon-' + code;
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xQQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTooltip_vue__ = __webpack_require__("eGfA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70bd339e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTooltip_vue__ = __webpack_require__("L5nV");
function injectStyle (ssrContext) {
  __webpack_require__("gSMt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70bd339e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70bd339e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xqJG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xrBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__ = __webpack_require__("ZoX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_078d9962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__ = __webpack_require__("313/");
function injectStyle (ssrContext) {
  __webpack_require__("GFiP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-078d9962"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_078d9962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xrxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLinkGroup_vue__ = __webpack_require__("5AYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5169db3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLinkGroup_vue__ = __webpack_require__("ClNt");
function injectStyle (ssrContext) {
  __webpack_require__("4pm6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLinkGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5169db3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLinkGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yBS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-breadcrumbs',

  props: {
    breadcrumbs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  watch: {
    $route: function $route(route) {
      this.addBCElement(route);
    }
  },

  mounted: function mounted() {
    this.addBCElement(this.$route);
  },


  methods: {
    addBCElement: function addBCElement(route) {
      var pathSplit = route.path.split('admin');
      var lPathSplit = pathSplit.length - 1;
      var routeSplit = pathSplit[lPathSplit].split('/');
      var p = '/admin';
      this.breadcrumbs.splice(0, this.breadcrumbs.length);
      for (var k in routeSplit) {
        if (routeSplit[k] === '') {
          routeSplit.splice(k, 1);
        }
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(routeSplit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          var n = item.indexOf('-') > 0 ? item.substr(item.indexOf('-') + 1, item.length) : item;
          p += '/' + item;
          var elem = {
            'path': p,
            'meta': {
              'title': this.capitalizeFirstLetter(n),
              'breadcrumbDisabled': !this.isNotNullorUndefined(item) || routeSplit.length > 1 && routeSplit.indexOf(item) === 0
            }
          };
          this.breadcrumbs.push(elem);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "yPiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__ = __webpack_require__("YPsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b7e4dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__ = __webpack_require__("FmT6");
function injectStyle (ssrContext) {
  __webpack_require__("03Zi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b7e4dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yiDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{attrs:{"popover-class":_vm.popoverClass,"open":_vm.open,"disabled":_vm.disabled,"placement":_vm.placement,"auto-hide":_vm.autoHide}},[_vm._t("trigger"),_vm._v(" "),_c('template',{attrs:{"slot":"popover"},slot:"popover"},[(_vm.isIconPresent)?_c('div',{staticClass:"popover-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popover-content"},[_c('div',{staticClass:"popover-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"popover-body"},[_vm._t("body")],2)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ypPw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-feed"},[(_vm.posts.length == 0)?_c('div',{staticClass:"empty"},[_vm._v("Your feed is empty.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.posts),function(post){return _c('div',{staticClass:"post",class:{last: _vm.posts.indexOf(post) === _vm.posts.length - 1}},[_c('div',{staticClass:"photo-container"},[_c('div',{staticClass:"photo",style:(("background: url(" + (post.photoURL) + ")"))})]),_vm._v(" "),_c('div',{staticClass:"underscored"},[_c('span',{staticClass:"text"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(post.name))]),_vm._v(" "+_vm._s(post.text)+".")]),_vm._v(" "),_c('button',{staticClass:"btn btn-micro btn-primary btn-with-icon close-btn rounded-icon",on:{"click":function($event){_vm.removePost(post)}}},[_c('i',{staticClass:"ion-md-close ion"})])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yx39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bar",staticClass:"vuestic-progress-bar"},[(_vm.type == 'horizontal')?_c('horizontal-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'vertical')?_c('vertical-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'circle')?_c('circle-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"color":_vm.color,"background-color":_vm.backgroundColor,"start-color":_vm.startColor,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zb58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"].extend({
  props: ['chartData', 'options'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp],
  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.chartData, options);
  }
}));

/***/ }),

/***/ "zkRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
});

/***/ }),

/***/ "ztJv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f8823ae0354f5de29fd6.js